/* tslint:disable */
export default {
  "version": "0.0.0",
  "en": {
    "PAGE_TITLE": {
      "ABOUT": "About",
      "AUTOMATION_RULES": "Automation Rules",
      "AREAS": "Areas",
      "DASHBOARD": "Dashboard",
      "DEVICES": "Devices",
      "LOCATIONS": "Locations",
      "MICROAPPS": "Micro Apps",
      "RAINBEE_DETAILS": "Rainbee Details",
      "SCENES": "Scenes",
      "SECURITY_PANEL": "Security Panel",
      "SHOP": "Store",
      "SIGN_IN": "Sign In!",
      "SIGN_UP": "Sign Up!",
      "SUPPORT": "Support"
    },
    "BUTTON": {
      "AREAS_BELONG": "Areas It Belongs To",
      "CANCEL": "Cancel",
      "CHANGES": "Changes",
      "CLEAR": "Clear",
      "CONFIRM": "Confirm",
      "CONNECT": "Connect",
      "CONTINUE": "Continue",
      "CREATE_ACCOUNT": "Create Account",
      "FORGOT_PASSWORD": "Forgot Password?",
      "LEARN_MORE": "Learn more",
      "LOGOUT": "Logout",
      "NEXT": "Next",
      "NO": "No",
      "OK": "OK",
      "RECOVER_PASSWORD": "Recover Password",
      "REFRESH": "Refresh",
      "RETRY_NOW": "Retry now",
      "SAVE": "Save",
      "SET_BUTTON": "Set Button",
      "SIGN_IN": "Sign In",
      "SIGN_UP": "Sign Up",
      "USE_ID": "Use ID",
      "VIEW_ALL": "View All",
      "YES": "Yes"
    },
    "LABEL": {
      "ABOVE": "Above",
      "ACCOUNTS": "Accounts",
      "ACTION": "Action",
      "ACTIVE": "Active",
      "ADD": "Add",
      "ADD_ANOTHER_DEVICE": "Add another Device >",
      "ADD_DIFFERENT_DEVICE": "Add a different device >",
      "ADD_NOW": "Add Now",
      "ADD_TO_AREA": "Add to Another Area",
      "ADD_TO_NEXT_AREA": "Add to the following Area",
      "ADD_DEVICE": "Add New Device",
      "ADD_DEVICES": "Add Devices",
      "ADDED_TO": "added to",
      "AFTER": "After",
      "ALL": "all",
      "ALL_DEVICES": "All Devices",
      "ANALOG": "Analog",
      "ANY": "any",
      "AREA": "Area",
      "AT": "At",
      "AUTOMATION_RULE": "Automation Rule",
      "BEFORE": "Before",
      "BILLING_CYCLE": "Billing Cycle",
      "BELOW": "Below",
      "BUTTON": "Button",
      "CEILING": "Ceiling",
      "CHANGE": "Change",
      "CHANGE_COLOR": "Change Color",
      "CHANGE_LOCATION": "Change Location",
      "CLOSE": "Close",
      "COLOR": "Color",
      "CONDITION": "Condition",
      "CONDITION_MET": "condition met:",
      "CONDITIONS_MET": "of these conditions are met:",
      "CONFIRM": "Confirm",
      "CONFIRM_DELETE": "Confirm deletion",
      "CONTINUE_DASHBOARD": "Continue to Dashboard",
      "CONTROL_PATH": "Control Path",
      "CONTROLLER": "Controller",
      "CONTROLLERS": "Controllers",
      "COST": "Cost",
      "CURRENCY": "Currency",
      "CURRENT_PASSWORD": "Current Password",
      "CUSTOM": "Custom",
      "CYCLE": "Cycle",
      "DAY": "Day",
      "DAYS": "Days",
      "DELAY": "Delay",
      "DELETE": "Delete",
      "DELETED": "Deleted",
      "DETAILS": "Details",
      "DEVICE": "Device",
      "DEVICE_ADDED": "Device Added",
      "DEVICES": "Devices",
      "DEVICE_STATUS": "Device Status",
      "DIGITAL": "Digital",
      "DISABLE": "Disable",
      "DISTANCE": "Distance",
      "DO": "do",
      "DONE": "Done",
      "DURATION": "Duration",
      "EDIT": "Edit",
      "EDIT_INFO": "Edit Information",
      "EDIT_SUB_DEVICE_NAME": "Edit Sub-Device Name",
      "EFFECT": "Effect",
      "EMAIL": "Email",
      "ENABLE": "Enable",
      "ENERGY": "Energy",
      "ENERGY_COST_BILLING_CYCLE": "Energy Cost Billing Cycle",
      "ENERGY_COST_SETUP": "Energy Cost Setup",
      "ENERGY_COST_STRUCTURE": "Energy Cost Structure",
      "ENERGY_MANAGEMENT": "Energy",
      "ENERGY_USAGE": "Energy Usage",
      "EVEN_DATES": "Even dates",
      "EVENTS": "Events",
      "EVERYDAY": "Everyday",
      "FIND_DEVICE": "Finding Devices...",
      "FIRMWARE": "Firmware",
      "FIXED_TIME": "Fixed Time",
      "FOUND": "Found",
      "GENERAL_SETTINGS": "General Settings",
      "GO_TO_DASHBOARD": "Go to Dashboard",
      "HARDWARE": "Hardware",
      "HISTORY": "History",
      "HONEYWELL_DEVICES": "Honeywell Devices",
      "HOUR": "Hour",
      "HOURS": "hours",
      "HOURSM": "Hours",
      "HOUSE_CODE": "House Code",
      "HUB_NEEDED": "Hub Needed!",
      "IMAGE_PATH": "Image Path",
      "IN": "in",
      "INI_WEEK": "W",
      "INI_YEAR": "Y",
      "INPUT": "Input",
      "INPUT_DEVICE": "Input device",
      "INPUTS": "Inputs",
      "INTERFACE_NEEDED": "Interface Needed!",
      "INTERVAL_TIME": "Interval Time",
      "IP_ADDRESS": "IP Address",
      "KILOMETERS": "Kilometers",
      "LANGUAGE": "Language",
      "LAST_NAME": "Last Name",
      "LOAD_MORE": "Load more...",
      "LOADING": "Loading",
      "LOCATION": "Location",
      "LOCATION_ADDED": "Location Added",
      "LOCATION_INFO": "Location information",
      "LOCATION_SETTINGS": "Location Settings",
      "LOWER": "Lower",
      "MAC": "MAC",
      "MESSAGE": "Message",
      "METRIC_UNITS": "Units",
      "MICROAPP": "Micro App",
      "MILES": "Miles",
      "MINUTE": "Min",
      "MINUTES": "Minutes",
      "MONTHS": "Months",
      "MORE_THAN": "More than",
      "MY_LOCATION_NAME": "My location name",
      "MY_LOCATION_ZIP": "My location ZIP Code",
      "MY_LOCATION_ADDRESS": "My location address (optional)",
      "MY_MICROAPP_NAME": "My micro app name",
      "NAME": "Name",
      "NEST_DEVICES": "Nest Devices",
      "NEW": "New",
      "NO": "No",
      "NO_RECENT": "Nothing recently ...",
      "NOT_FOUND": "Not Found",
      "ODD_DATES": "Odd dates",
      "OFF": "Off",
      "ON": "On",
      "OPTION": "Option",
      "OUTPUTS": "Outputs",
      "PAIRING": "Pairing",
      "PAIRINGS": "Pairings",
      "PASSWORD": "Password",
      "PERFECT": "Perfect!",
      "PHONE": "Phone",
      "PORT": "Port",
      "PRICE": "Price",
      "PRICES": "Prices",
      "PRIVACY_POLICY": "Privacy Policy",
      "PROFILE": "Profile",
      "PROGRAM_NAME:": "Program name",
      "RANDOM_TIME": "Random Time",
      "RANGE": "Range",
      "READY_ADD": "Ready to Add?",
      "REMOVE": "Remove",
      "REMOVED_FROM": "removed from",
      "RESPONDER": "Responder",
      "RETRY": "Retry",
      "RETRYING": "Retrying",
      "RULE": "Rule",
      "RULE_NAME": "Rule Name",
      "SAVING": "Saving",
      "SCENE": "Scene",
      "SCENE_CONTROLLER_NEEDED": "Scene Controller Needed!",
      "SCENE_NAME": "Scene name",
      "SCENE_RESPONSE": "Scene Response Group",
      "SCHEDULE": "Schedule",
      "SCHEDULE_NAME": "Schedule Name",
      "SEARCH": "Search",
      "SECOND": "Sec",
      "SETTINGS": "Settings",
      "SETUP": "Set Up",
      "SKIP": "Skip",
      "SLOGAN": "Life. Simplified!",
      "SLOT": "Slot",
      "SLOTS": "Slots",
      "SNAPSHOT_PORT": "Snapshot Port",
      "SOFTWARE": "Software",
      "STANDARD": "Standard",
      "START_TIMES": "Start Times",
      "SUBJECT": "Subject",
      "SUMMARY": "Summary",
      "SUNRISE": "Sunrise",
      "SUNSET": "Sunset",
      "TEMPERATURE_UNITS": "Temperature Unit",
      "TERMS_AND_CONDITIONS": "Terms and Conditions",
      "THE_AREA": "the Area",
      "THE_DEVICE": "the Device",
      "THE_FOLLOWING": "the following:",
      "THE_LOCATION": "the Location",
      "THE_ZONES": "the zones",
      "THEN": "Then",
      "THESE_DAYS": "These Days",
      "THIS_PROGRAM": "this program",
      "THIS_TIME": "This time",
      "TIER": "Tier",
      "TIERED": "Tiered",
      "TIME_OF_USE": "Time of Use",
      "UNIT_CODE": "Unit Code",
      "UPPER": "Upper",
      "USERNAME": "Username",
      "VERSION": "Version",
      "VIEW_LESS": "View less",
      "VIEW_MORE": "View more",
      "WARNING": "Warning",
      "WATERING_DAYS": "Watering Days",
      "WE_FOUND": "We found",
      "WHEN": "When",
      "WINDOW_TIME": "Window Time",
      "YOU_CAN_ADD": "you can add",
      "YOUR_PROFILE": "Your Profile",
      "ZONE_TIMERS": "Zone Timers",
      "ZONES_LIST": "Zones List"
    },
    "DAYS": {
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "SUNDAY": "Sunday"
    },
    "MONTHS": {
      "JANUARY": "Jan",
      "FEBRUARY": "Feb",
      "MARCH": "Mar",
      "APRIL": "Apr",
      "MAY": "May",
      "JUNE": "Jun",
      "JULY": "Jul",
      "AUGUST": "Aug",
      "SEPTEMBER": "Sep",
      "OCTOBER": "Oct",
      "NOVEMBER": "Nov",
      "DECEMBER": "Dec"
    },
    "TEXT": {
      "ACCOUNT_ALREADY_EXISTS": "Account already exists",
      "ACCOUNT_DELETE_CONFIRMATION": "Do you want to delete this account? The devices associated with this account will be removed",
      "ACCOUNT_DELETE_ERROR": "Sorry, there was an error unlinking the account",
      "ACCOUNT_DELETE_SUCCESS": "The account has been successfully unlinked",
      "ACTIONS_EXPLANATION_TEXT": "Actions are the part of your Rules that happen once your Conditions are fulfilled.",
      "ADD_CONDITION_TO": "Adding condition on",
      "ADD_DEVICES": "+ Add Devices",
      "ADD_EFFECT_TO": "Adding effect on",
      "ADD_GATEWAY_STEP": "This gateway is able to connect using Ethernet and WiFi. Click the Add now button below and we will guide you to setup.",
      "ADD_GATEWAY_STEP_RES": "Click the Add now button when you are ready and we will guide you to setup.",
      "ADD_RESPONDER_TO": "Adding Responder to",
      "ADD_RULES": "Click the + button on top right to start adding Automation Rules!",
      "ADD_SCENE_TEXT": "Click the + button on top right to start creating Scenes!",
      "ADD_MICROAPPS": "Click the + button on top right to add and configure your first Micro App!",
      "ADDING_YOUR": "Adding your",
      "ADDRESS": "Address",
      "ALL_RIGHTS_RESERVED": "All rights reserved",
      "APP_DESCRIPTION": "Smartenit helps you monitor and control your energy and\nwater use, manage lighting, improve comfort, and\nmore!",
      "AREA_DELETE_CONFIRMATION": "Do you want to delete this area?",
      "BELOW_FACTORY_RESET": " below to factory reset then press the retry button. Or go back to dashboard.",
      "BY_SIGNING_UP": "By signing up you agree to the",
      "CHANGE_LOCATION": "Change location",
      "CHANGE_LOCATION_DESCRIPTION": "Select the location where you want to move this gateway and its devices",
      "CLOSER_ROUTER_WIFI": "closer to your WiFi router",
      "COME_BACK_WIFI": "Come back to this screen. If the connection to the network is successful, then you will see a list of nearby WiFi networks",
      "CONDITIONS_EXPLANATION_TEXT": "Conditions are the part of your Rules that need to happen in order to trigger your Actions.",
      "CONNECTION_ERROR": "Connection error",
      "CONNECTION_ERROR_GW": "There was an error connecting to your gateway, do you want to try again?",
      "CONNECT_WIFI_NETWORK": "Connect to your WiFi network",
      "CONNECT_YOUR": "Connect your",
      "CONNECTED_SUCCESS": "connected successfully!",
      "CONFIGURE_CONTROLLER_FOR": "Configuring Controller for",
      "CONFIRM": "Are you sure?",
      "CONFIRM_DELETE": "Do you want to delete this entry?",
      "CONFIRM_DELETE_CONDITION": "Do you want to delete this condition?",
      "CONFIRM_DELETE_EFFECT": "Do you want to delete this effect?",
      "CONFIRM_DELETE_LOCATION": "Do you want to delete this location?",
      "CONFIRM_DELETE_MICROAPP": "Do you want to delete this micro app?",
      "CONFIRM_DELETE_RULE": "Do you want to delete this rule?",
      "CONFIRM_DELETE_SCENE": "Do you want to delete this scene?",
      "CONTINUE_ADDING_DEVICES": "Continue to Add Devices",
      "CREATE_NEW_AREA": "Click the + button on top right to start creating Areas!",
      "DELETE_DEVICES_QUESTION": "Would you also like to delete all devices from this gateway?",
      "DEVICE_DELETE_CONFIRMATION": "Are you sure want to delete this device permanently?",
      "DISCOVERY_DEVICES_WARNING_1": "Your gateway seems to have a problem, please reboot it.",
      "DISCOVERY_DEVICES_WARNING_2": "Your gateway is offline, please check the internet connection or reboot it.",
      "DURATION_SIREN_VALIDATION": "The duration of the alarm must be equal or greater than 1 second",
      "EM_SLOTS_ASSOCIATED_WITH_PRICE": "There are slots associated with this price",
      "EM_TIER_RANGE_CONFLICT": "This tier range conflicts with",
      "EM_TIME_RANGE_SEPARATION": "Upper time must be after lower time by at least",
      "EM_TIME_RANGE_SLOT_CONFLICT": "This time range conflicts with slot",
      "ENERGY_COST_BILLING_CYCLE": "Billing cycle starts on the",
      "ENERGY_COST_BILLING_CYCLE_DESC": "Please enter the start day of your billing period. \n\nFor example: If your billing period is from Aug 5th to Sep 4th, then enter 5 below.\n",
      "ENTER_ADDRESS_OR_MAP_OR_ZIP": "Enter an address, or, if geolocation is enabled, find it on the map below or enter only the ZIP Code",
      "ENTER_WIFI_PASSWORD": "Enter WiFi password for",
      "ERROR_AUTORULE_NAME": "Please enter a valid Automation Rule name",
      "ERROR_CONFIRM_PASS": "Please enter new password",
      "ERROR_CREATING_DEVICE": "Error creating device, please try again",
      "ERROR_CURRENCY": "Please select the currency",
      "ERROR_EFFECT_OBJECT": "Effect object was not created correctly",
      "ERROR_GATEWAY_ACTION": "Action object was not created correctly",
      "ERROR_GATEWAY_CONDITIONS": "Your Gateway does not support time based conditions",
      "ERROR_GATEWAY_GET_PROCESSOR": "Gateway object does no have function getProcessor",
      "ERROR_HOUSE_CODE": "House Code is invalid, a house code is character from A-P",
      "ERROR_IP_ADDRESS": "Ip Address is wrong, ",
      "ERROR_LANGUAGE": "Please select the language",
      "ERROR_LAST_NAME": "Please enter your Last Name",
      "ERROR_NAME": "Please enter your First Name",
      "ERROR_MATCH_PASS": "Passwords do not match, please try again",
      "ERROR_NEW_PASS": "Please enter new password",
      "ERROR_OLD_PASS": "Please enter your old password",
      "ERROR_PORT": "Port is wrong,",
      "ERROR_REMOVING_DEVICES": "There was an error removing the devices, please try again",
      "ERROR_REMOVING_GATEWAY": "There was an error removing the gateway, please try again",
      "ERROR_SAVING_DEVICE": "There was an error saving the device. Please make sure the correct credentials were entered",
      "ERROR_SCENE_NAME": "Please enter a valid Scene name",
      "ERROR_START_TIME_CONDITION": "Start times Condition was not created correctly",
      "ERROR_TEMPERATURE": "Please select metric unit",
      "ERROR_UNIT_CODE": "Unit Code is invalid, a unit code is a number from 1-16",
      "ERROR_WATERING": "Watering days Condition was not created correctly",
      "FIXED_TIME_SELECTED": "Fixed Time selected. ",
      "FORGOT_PASS_SUCCESS": "Success! Please check email to reset password.",
      "GATEWAY_HUB_NEEDED": "This device requires a Gateway/ Hub in order to be added",
      "GATEWAY_PHONE": "Make sure your phone is on the same network",
      "GATEWAY_WITH_PROTOCOLE": "<ul><li>Gateway is now in Pairing mode, the device should join automatically</li><li>Click continue to go back to Discover page, if your device pairs, then you will see: \"Found 1 Device\"</li></ul>",
      "GATEWAY_WITHOUT_INSTEON": "Your Gateway does not have an Insteon interface to add this device. Please contact support for additional details",
      "GATEWAY_WITHOUT_X10": "Your Gateway does not have a X10 interface to add this device. Please contact support for additional details",
      "GATEWAY_WITHOUT_ZIGBEE": "Your Gateway does not have a Zigbee interface to add this device. Please contact support for additional details",
      "HONEYWELL_ADD_DEVICE_ERROR": "There was a problem adding one or more Honeywell devices, please try again",
      "HONEYWELL_CONNECT_TITLE": "Connect to Honeywell",
      "HONEYWELL_CONNECT_DESCRIPTION": "In order to add and interact with Honeywell devices, please connect to your Honeywell account",
      "HONEYWELL_CONNECT_ERROR": "There was a problem connecting with your Honeywell account, please try again",
      "HONEYWELL_GET_DEVICES_ERROR": "There was a problem retrieving your Honeywell devices",
      "HONEYWELL_NO_DEVICES": "No Honeywell devices found in your account",
      "IMAGE_SOURCE": "Select Image Source",
      "INFO_ADD_DEVICES": "Click the continue button to go to the Add Devices page. In the Add Devices page, click on the Devices Found tab at the top of the page to finish adding your new device",
      "INSTEON_ADD_ERROR": "There was an error adding your Insteon device, please try again",
      "INSTEON_ADD_INSTRUCTIONS": "Which option do you want to use to add this Insteon device?",
      "INSTEON_ADD_INVALID_ID": "This ID is invalid, make sure it has 6 characters, either numbers or letters",
      "INSTEON_PRESS_HOLD": "Press and hold the set button of the device to put it",
      "INTERVAL_TIME_SELECTED": "Interval time selected",
      "INVALID_DEVICE": "There was a problem adding device %deviceMac%. Please factory reset it and try again.",
      "LEAST_ONE_LOCATION": "You must have at least one location",
      "LETS_CONNECT": "Let's connect the",
      "LINKING_MODE": "into linking mode.",
      "LOAD_GALLERY": "Load from Gallery",
      "LOCATION_ADDRESS_INFO": "The location address helps us provide you features such as GeoFencing, Microclimate, and more. This is optional.",
      "LOCATION_ADDRESS_TITLE": "Location Address",
      "MICROAPPS_DOORBELL_TRIGGER_DEVICES_INTRO": "Please select a trigger device",
      "MICROAPPS_NO_CAMERA": "No camera configured",
      "MICROAPPS_SETUP_INTRO": "Let's select devices to configure your Micro App",
      "NAME_REQUIRED": "Name is required",
      "NEED_MORE_TIME": "Do you need more time for adding devices?",
      "NEST_ADD_DEVICE_ERROR": "There was a problem adding one or more Nest devices, please try again",
      "NEST_CONNECT_TITLE": "Connect to Nest",
      "NEST_CONNECT_DESCRIPTION": "In order to add and interact with Nest devices, please connect to your Nest account",
      "NEST_CONNECT_ERROR": "There was a problem connecting with your Nest account, please try again",
      "NEST_GET_DEVICES_ERROR": "There was a problem retrieving your Nest devices",
      "NEST_NO_DEVICES": "No Nest devices found in your account",
      "NO_ABLE_ADD_DEVICE": "We were not able to add the device. Please make sure that the credentials you entered were correct. Then press the retry button.",
      "NO_ADDED_CONTROLLERS": "You have not added any Controllers",
      "NO_ADDED_RESPONDERS": " You have not added any Responders",
      "NO_AREAS_CREATED": "No Areas created yet.",
      "NO_AREAS_EXPLANATION_TEXT": "Areas are a way to organize devices for quick access. For example, create a \"Living Room\" Area for all the devices in your living room.",
      "NO_AVAILABLE_LOCATIONS": "There are no available locations to perform this action",
      "NO_CONTROLLERS_EXPLANATION_TEXT": " Use the (+) icon to add one or more devices that will activate the scene. For example: With a keypad you will be able to select a specific button.",
      "NO_DEVICES_EXPLANATION_TEXT": "Devices are all the things around you (sensors, lights, switches) that you want to connect, control, and schedule!",
      "NO_PRICES_YET": "No Prices yet.",
      "NO_RECENT_EVENTS_TEXT": "There are no recent events",
      "NO_RESULTS": "No results for this search",
      "NO_RULES_EXPLANATION_TEXT": "Using Automation Rules you can schedule and automate your devices. For example \"Turn On the Lights at sunset.\"",
      "NO_RULES_YET": "No Automation Rules yet.",
      "NO_SCENES_EXPLANATION_TEXT": "Use the (+) icon to add and configure one or more devices in a scene. These \"responders\" will simultaneously go to a preset behavior when the scene is activated.",
      "NO_SCENES_TEXT": " Using Scenes you can control multiple devices with the touch of one button!",
      "NO_SCENES_YET": "No Scenes yet",
      "NO_MICROAPPS_DEVICES_SUPPORTED_YET": "There are no devices supported by this slot",
      "NO_MICROAPPS_TRIGGER_DEVICES_YET": "There are no devices in this Micro App to be used as trigger devices",
      "NO_MICROAPPS_EXPLANATION_TEXT": "Using Micro Apps, you can group devices for use in practical scenarios. For example, a Doorbell Micro App allows you to group a Camera, Doorbell, Motion Sensors, DoorLocks, and Lights.",
      "NO_MICROAPPS_YET": "No Micro Apps yet.",
      "NO_THIRD_PARTY_ACCOUNTS": "You do not have any 3rd party accounts linked",
      "NO_TIERS_YET": "No Tiers yet.",
      "NOT_SEE_NETWORK": "If you do not see your network, then make sure to plug the",
      "NOT_UNDONE": "This cannot be undone",
      "OFFLINE_CONNECTION": "The connection with the server has been lost. Please check your internet connection.",
      "OFFLINE_CONNECTION_RECONNECT": "The connection with the server has been lost. Trying to reconnect...",
      "OPEN_ETHERNET_PORT": "gateway to an open ethernet port.",
      "PASSWORD_POLICY_START" : "The password must contain at least:",
      "PASSWORD_POLICY" : "8 characters, one upper-case letter, one lower case letter, one number and one symbol",
      "PLEASE_CHECK_CONNECTION": "Please check your internet connection",
      "PLEASE_CONNECT_SAME_NETWORK": "Please go to WiFi settings and connect to the WiFi network: \"{{wifi_network}}\". Then come back to finish adding the device.",
      "PLEASE_FOLLOW_DIRECTIONS": "Please follow the directions in the",
      "PLEASE_GO_WIFI_SETTINGS": "Please go to your WiFi settings and connect to the Smartenit IoT Hotspot",
      "PLEASE_SELECT": "Please select ",
      "PLEASE_SELECT_ACTION": "Please select an action",
      "PLEASE_SELECT_CONTROL": "Please select the control",
      "PLEASE_SELECT_DELAY": "Please select a delay (optional)",
      "PLEASE_SELECT_DEVICE": "Please select a device",
      "PLEASE_SELECT_DEVICE_PAIRINGS": "Please select a device to control",
      "PLEASE_SELECT_END_DATE": "Please select the End date: ",
      "PLEASE_SELECT_END_TIME": "Great! Now please select the End time:",
      "PLEASE_SELECT_INTERVAL": "Great! Please select the interval: ",
      "PLEASE_SELECT_OFFSET": "Now please select the offset:",
      "PLEASE_SELECT_RESOURCE": "Please select a resource",
      "PLEASE_SELECT_STARTING_DATE": "Now please select the starting date:",
      "PLEASE_SELECT_STARTING_TIME": "Now please select the starting time:",
      "PLEASE_SELECT_TYPE_CONDITION": "Please select the type of condition",
      "PLEASE_TRY_AGAIN": "please try again",
      "PRESS_TO_ADD_ACTION": "Add an Action by pressing the (+) button in the top right corner",
      "PRESS_TO_ADD_CONDITION": "Add a Condition by pressing the (+) button in the top right corner",
      "PRESS_TO_CONTROL_DEVICES": "Press the + button to control other devices with this button",
      "PRICE_DELETE_CONFIRMATION": "Do you want to delete this price?",
      "PROMOTIONAL_CONTENT_CONSENT": "I want to receive promotional content and offers from Smartenit",
      "PULL_TO_REFRESH": "Pull to load new Events",
      "RANDOM_TIME_SELECTED": "Random time selected",
      "RECOVER_PASSWORD_INSTUCTIONS": "Please enter your email. We'll email instructions on how to reset the password.",
      "REMOVE_DEVICES": "Remove devices",
      "RETRYING_IN": "Retrying in",
      "REVERSE_INPUT_POLARITY": "Reverse Input Polarity",
      "SCENE_CREATE_ERROR": "You need a device with the scene controller capability",
      "SCHEDULE_YOUR_PROGRAM": "Schedule Your Program",
      "SELECT_ACTIVE_DAYS": "Select the active days",
      "SELECT_DEVICE": "Select a device",
      "SELECT_HONEYWELL_DEVICES": "Select the Honeywell devices you want to add:",
      "SELECT_NEST_DEVICES": "Select the Nest devices you want to add:",
      "SELECT_SOUND_TYPE": "Select sound type: ",
      "SELECT_TO_CONNECT": "Select the devices you want to connect",
      "SELECT_WIFI_NETWORK": "Select your WiFi Network:",
      "SET_LOCATION_GUIDE_ADD_DEVICES": "Now set up your location. Then you'll be guided to add new devices",
      "SIGN_UP_SUCCESS": "Your account has been created successfully, please check your email for the confirmation link",
      "SKIP_THIS_STEP": "Skip this step >",
      "SLOT_DELETE_CONFIRMATION": "Do you want to delete this slot?",
      "SUMMARY_OF_ACTION": "Summary of the action will show here as you set it up",
      "SUMMARY_OF_CONDITION": "Summary of the condition will show here as you set it up",
      "SUMMARY_OF_CONTROLLER": "Summary of the controller will show here as you set it up",
      "SUMMARY_OF_RESPONDER": "Summary of the responder will show here as you set it up",
      "SUMMARY_PAIRING": "Summary of the pairing setup will show here as you set it up",
      "SUNRISE_SELECTED": "Sunrise selected.",
      "SUNSET_SELECTED": "Sunset selected.",
      "TAP_CHANGE_PICTURE": "Tap to change the picture",
      "THEN_CLICK_ADD": "Then click the \"Add Now\" button below.",
      "THERE_WAS_PROBLEM": "There was a problem saving the",
      "THIS_MAY_TAKE_A_FEW_SECONDS": "This may take a few seconds",
      "TIER_DELETE_CONFIRMATION": "Do you want to delete this tier?",
      "TO_YOUR_NETWORK": "to your network",
      "UPDATED_SUCCESSFULLY": "Updated successfully!",
      "USE_CAMERA": "Use Camera",
      "VALIDATION_LENGTH_PASS": "must be at least 8 characters",
      "VALIDATION_LOWER_PASS": "must have a lowercase character",
      "VALIDATION_NUMBER_PASS": "must have a number",
      "VALIDATION_SYMBOL_PASS": "has an invalid symbol, please check and try again",
      "VALIDATION_UPPER_PASS": "must have an uppercase character",
      "WHICH_DAYS_OF_SELECTED": "Which days on the Selected days?",
      "WHICH_DAYS_OF_WEEK": "Which days of the week?",
      "WIFI_PROV_FIND_DEVICE": "Registering your {{device_name}}. This can take a minute...",
      "WINDOW_TIME_SELECTED": "Window time selected.",
      "X_TEN_TAKE_NOTE": "Take note of your X10 device's house code and unit code.",
      "YES_STILL_ADDING": "Yes, I'm still adding",
      "ZIGBEE_FACTORY_RESET": "Factory reset the",
      "ZIGBEE_FOLLOW_INSTRUCTIONS": "Follow the instructions in the product manual.",
      "ZIP_CODE_REQUIRED": "ZIP Code is required",
      "ZONE_TIMERS_UPDATE": "Here you can update the Zone timers for"
    },
    "SYMBOL": {
      "AMPERSAND": " & ",
      "COMA": ", "
    },
    "WIZARD": {
      "CENTRALITE_HA_THERMOSTAT": "Control and monitor your home temperature from anywhere. Connects to Smartenit Gateway with Zigbee.",
      "CENTRALITE_PEARL_THERMOSTAT": "Control and monitor your home temperature from anywhere. Connects to Smartenit Gateway with Zigbee.",
      "RADIO_THERMOSTAT_ZIG": "Control and monitor your home temperature from anywhere. \n\nSupported Thermostats: ZigBee enabled CT-32 and CT-80",
      "GATEWAY_HARMONY_G2": "Small but powerful smart home Gateway that allows you to control and monitor various smart devices.",
      "GATEWAY_HARMONY_P2": "Monitor and control anything, from anywhere with Harmony P2",
      "GATEWAY_HARMONY_G1": "Monitor and control anything, from anywhere and optionally turn any PC monitor, projector, or TV into a Smart media center",
      "THERMOSTAT_3M_50_WIFI": "Control and monitor your home temperature from anywhere.\n\nSupported Thermostats: Wi-Fi enabled CT-50 and CT-80",
      "SWITCHES_OUTLET_ZBMPLUG15": "This smart plug adapter tracks energy consumption data while also allowing remote on/off control for complete energy management",
      "INPUT_OUTPUT_CONT_EZIO8SA": "You can trigger small devices, alarms, and events using incoming signals from sensors by setting up a centralized EZIO8SA",
      "INPUT_OUTPUT_CONT_EZIO2X4": "Monitor and control small devices, alarms, and events using incoming signals from sensors by setting up a centralized EZIO2x4",
      "INPUT_OUTPUT_CONT_EZIO40": "Control up to 4 small devices from anywhere with this input/output device",
      "SWITCHES_OUTLET_ZBLC15": "Monitor and control two devices such as overhead lights, ceiling fans, and small appliances plugged into power outlets or controlled by wall switches, with a controller that can be hidden anywhere",
      "SWITCHES_OUTLET_IOT4R": "Control up to 4 small devices from anywhere with this input/output device.",
      "SWITCHES_OUTLET_ZBMLC30": "Extend energy management and remotely monitor and control up to two of your largest energy-consuming appliances with a ZBMLC30",
      "SWITCHES_OUTLET_ZBMLC15": "Monitor and control appliances, overhead lights, ceiling fans, and more all from behind a switch or outlet, or anywhere",
      "KEYPAD_BUTTONS_ZBWS3B": "This battery operated, wireless 3 button switch can link to various ZigBee devices. A single button can control multiple devices to create scenes.",
      "OTHER_ZBVC_1": "This wireless controller easily installs onto existing ball valves to give you pinpoint control over your water or gas lines.",
      "SENSOR_ZBHT_2": "Make yourself and your home control system aware of the temperature and humidity anywhere with the addition of this battery-operated sensor with a built-in display",
      "SENSOR_ZBMS3_1": "This sensor provides information on motion, temperature, and ambient light that can then be used to influence other devices",
      "SENSOR_ZBWDS": "Use this ZigBee HA (Home Automation Profile) wireless sensor to monitor doors, cabinets, and windows",
      "IRRIGATION_RAINBEE_8": "Maximize water and energy efficiency by using your irrigation system only when you want and need it.  RainBee8 lets you flexibly monitor and control up to 8 sprinkler zones independently",
      "KEYPAD_BUTTONS_ZBALRMB": "Use the ZBALRMB door bell and wireless switch to include your entryway in your home automation network.",
      "LIGHTS_GE_LINK_BULB": "Connect to Smartenit to easily control and monitor your light. Allows you to brighten/dim and turn on/off remotely. Add it to Automation Rules to automate lighting.",
      "LIGHTS_CREE_CONNECTED_LED": "Connect to Smartenit to easily control and monitor your light. Allows you to brighten/dim and turn on/off remotely. Add it to Automation Rules to automate lighting.",
      "LIGHTS_IKEA_TRADFRI_TUNABLE_WHITE": "Connect to Smartenit to easily control and monitor your light. Allows you to brighten/dim and turn on/off remotely. You can Tune the light to different temperatures such as Warm white and soft white. Add it to Automation Rules to automate lighting.",
      "LIGHTS_OSRAM_RGBW": "Adjust your lights from thousands of different colors. Beautiful high quality light that you can tune, dim, and control from the App. Products that support this are: \n1. A19 Full Color + Tunable White LED Bulb\n2. BR30 Full Color + Tunable White LED Bulb\n3. Recessed Light Full Color + Tunable White\n4. Flex Light Strip\n5. Landscape Lights, Gardenspots Full Color + Tunable White",
      "LIGHTS_OSRAM_WHITE": "Adjustable white LED bulb allows you to tune it to different shades of white light. Beautiful high quality light that you can tune, dim, and control from the App. Products that support this are: \n1. A19 Tunable White LED Bulb\n2. BR30 Tunable White LED Bulb\n3. Recessed Light Tunable White",
      "LIGHTS_OSRAM_DIMMABLE": "Beautiful high quality light that you can dim and control from the App. Products that support this are: \n1. A19 Tunable White LED Bulb\n2. BR30 Tunable White LED Bulb\n3. PAR38 Tunable White LED Bulb",
      "DOORLOCK_SMARTCODE_DEADBOLT": "Smartcode Deadbolt is a wireless door lock with coded entry",
      "DOORLOCK_CONTEMPORARY_SMARTCODE_DEADBOLT": "Contemporary Smartcode Deadbolt is a wireless door lock with coded entry",
      "DOOR_LOCK_SMARTCODE_LEVER": "Smartcode Lever With Home Connect is a wireless door lock with coded entry",
      "DOORLOCK": "Remotely control and monitor your doorlock by adding it to Smartenit Gateway. Take action by using these lock in our powerful automation rules.",
      "OTHER_ZBALRM": "Use the versatile ZBALRM siren to alert you when something happens in your home automation network. Capable of multiple different sounds like Burglar, Fire and Doorbell.",
      "SENSOR_ZBLIQS": "Use ZBLIQS to prevent damage from leaking pipes, overflowing condensation pans, leaking water heaters and more.",
      "OTHER_ZBPCM": "Get your whole house energy information directly from your electric meter in order to set up responsive, energy saving strategies and programs.",
      "SENSOR_ZBMS3": "This sensor provides information on motion, temperature, and ambient light that can then be used to influence other devices",
      "IRRIGATION_RAINBEE_16": "Maximize water and energy efficiency by using your irrigation system only when you want and need it.  RainBee16 lets you flexibly monitor and control up to 16 sprinkler zones independently",
      "IRRIGATION_EZFLORA": "You can monitor and control your irrigation system from anywhere with the EZFlora irrigation controller",
      "INSTEON_EZSNSRF": "Translate simple RF signals into sophisticated home automation commands with EZSnsRF",
      "INSTEON_EZUIRT": "You can connect your A/V system or other IR devices to your home control system and consolidate your remote controls using EZUIRT",
      "SWITCHES_OUTLET_ENERGY_SMART": "Smart In-wall Zigbee outlet that allows you to control and monitor an attached appliance (max 15A). You can also monitor the energy usage over time with built-in metering chip. The bottom outlet is controllable and top outlet is always On.",
      "SWITCHES_OUTLET_INSTEON_DIMMER": "Control your light remotely, turn it on/off or adjust brightness. Easily automate lights by using this device in Automation Rules.",
      "SWITCHES_OUTLET_INSTEON_PLUGIN": "Control plugged-in lamps and appliances remotely. Easily automate things by using this device in Automation Rules.",
      "SWITCHES_OUTLET_INSTEON_OUTLET_RECEP": "In-wall scene controller plus a switch to control your appliances. Connect to Smartenit and control your appliances remotely. Easily automate things by using this device in Automation Rules.",
      "SWITCHES_OUTLET_X10_DIMMER": "Remotely turn on/off and adjust the brightness of connected devices",
      "SWITCHES_OUTLET_X10_RELAY": "Turn on/off your appliances remotely with an X10 Appliance Module",
      "DOORLOCK_YALE_REAL_LIVING": "The Yale Real Living Lock is a ZigBee enabled keyless door lock",
      "CAMERAS_FOSCAM_FI9821P": "HD 720P WiFi Security IP Camera with Pan, Tilt, Zoom, Two-Way Audio, Night Vision up to 26ft, and More",
      "SELECT_AN_OPTION": "Select Option",
      "INFO_ADD_GATEWAY_START": "Your",
      "INFO_ADD_GATEWAY_METHOD": "can connect through Ethernet and WiFi. Please select below the option that you would like to use:",
      "USE_WIFI": "WiFi",
      "USE_ETH": "Ethernet",
      "NEST_PROTECT": "Connect and integrate Nest Protect with Smartenit App for actionable intelligence. Enhance performance with Automation Rules and interactivity with all your other devices.",
      "NEST_THERMOSTAT": "Connect and integrate Nest Thermostat with Smartenit App for actionable intelligence. Enhance performance with Automation Rules and interactivity with all your other devices.\n\nSupported Thermostats: Nest Learning Thermostat, Nest Thermostat E",
      "HONEYWELL_THERMOSTAT": "Connect and integrate Honeywell Lyrics Thermostats with Smartenit App for actionable intelligence. Enhance performance with Automation Rules and interactivity with all your other devices.",
      "GOOGLE_HOME": "Integrate Google Home with Smartenit for voice control. Enhance performance with easy interactivity with all your other devices.",
      "AMAZON_ALEXA": "Integrate Amazon Alexa with Smartenit for voice control. Enhance performance with easy interactivity with all your other devices.",
      "ZEN_THERMOSTAT": "Zen is a Smart Home thermostat that looks beautiful on your wall. Integrate with Smartenit to easily control the temperature for comfort. Available in black or white, Zen blends seamlessly into your existing interior design. Connects to Smartenit Gateway using Zigbee.",
      "NYCE_MOTION_SENSOR": "Easily detect Motion and take action by using it in our powerful Automation Rules to alert you or trigger things.\nSupported: NYCE Ceiling Motion Sensor and Curtain Motion Sensor",
      "NYCE_DOOR_WINDOW_SENSOR": "Easily detect if doors and windows are Opened or Closed. Take action by using it in our powerful Automation Rules to alert you or trigger things.",
      "EVSE": "Monitor, control, and customize your EV charging schedules.",
      "IOT8": "Compact, yet powerful, smart controller with 8 outputs for small to mid-sized loads (irrigation, entry access, HVAC zone control, etc.) and 6 inputs to monitor a variety of sensors (motion, temperature, humidity, liquid, etc.)"
    },
    "CATEGORIES": {
      "ALL": "All",
      "GATEWAYS_HUBS": "Gateways/Hubs",
      "CAMERAS": "Cameras",
      "LIGHTS": "Lights",
      "THERMOSTATS": "Thermostats",
      "INPUT_OUTPUT": "Input/Output",
      "DOOR_LOCKS": "Door Locks",
      "SENSORS": "Sensors",
      "SWITCHES_OUTLETS": "Switches/Outlets",
      "IRRIGATION": "Irrigation",
      "KEYPAD_BUTTONS": "Keypads/Buttons",
      "VOICE_CONTROL": "Voice Control",
      "OTHER": "Other"
    },
    "STEPS": {
      "DEFAULT": "Please follow the product manual to Factory reset the product. Then press Add Now button below.",
      "1_THERMOSTAT_3M_50_WIFI": "Follow the product manual to connect the thermostat to Wi-Fi",
      "2_THERMOSTAT_3M_50_WIFI": "Note down the IP address assigned to the thermostat. If not port forwarding, then use port 80 in the form later.",
      "3_THERMOSTAT_3M_50_WIFI": "Click Add now button below",
      "1_SWITCHES_OUTLET_IOT4R": "Plug IoT4R into an outlet. Then press the \"Add Now\" Button below",
      "1_CAMERAS_FOSCAM_FI9821P": "Follow the instruction guide above to connect your camera to the internet",
      "2_CAMERAS_FOSCAM_FI9821P": "Record the IP Address and the Port of the Foscam Camera",
      "1_NEST": "After completing the product installation with the Nest App, click the Add Now button below.",
      "1_HONEYWELL": "After completing the product installation with the Honeywell Lyric App, click the Add Now button below.",
      "1_GOOGLE_HOME": "Go to Actions section in Google Home app and select Smartenit. Authenticate with Smartenit username and password. Now, Google Home can access all the devices connected with Smartenit gateway.",
      "1_AMAZON_ALEXA": "Go to Skills section in Amazon Alexa app and select Smartenit. Authenticate with Smartenit username and password. Now, Amazon Alexa can access all the devices connected with Smartenit gateway.",
      "1_OSRAM": "Factory reset the product as follows:\nSwitch ON, wait for 3 seconds, then switch OFF. Do this 5 times in succession. The light will flash 3 times to confirm a reset. Now it can be added to the Smartenit Gateway. Press the Add Now button below.",
      "1_SMART_OUTLET": "Press Program Button for 15 seconds, until Status LED flashes three times (LED will flash once at 3 seconds, 10 seconds and 15 seconds), and then release.",
      "2_SMART_OUTLET": "Tap the Local Control Button once within 2 seconds. The Status LED will flash fast for a few seconds and then go out.",
      "3_SMART_OUTLET": "When you have followed the above instructions, press the Add button below",
      "1_THERMOSTAT": "Please follow the product manual to Factory reset the product. Then press Add Now button below.",
      "1_DOORLOCK_SMARTCODE_LEVER": "Open the plate on the back to access the pairing buttons.",
      "2_DOORLOCK_SMARTCODE_LEVER": "Press the right button 9 times.",
      "3_DOORLOCK_SMARTCODE_LEVER": "Press the left button 4 times.",
      "4_DOORLOCK_SMARTCODE_LEVER": "Press the Add button below.",
      "1_DOORLOCK_YALE_REAL_LIVING": "Put your palm on the Touch Screen and a number panel should appear.",
      "2_DOORLOCK_YALE_REAL_LIVING": "Enter your Master Code and then # (Example: 1234 and then #).",
      "3_DOORLOCK_YALE_REAL_LIVING": "Press 7 for Wireless Settings Mode.",
      "4_DOORLOCK_YALE_REAL_LIVING": "Press 1 and then #",
      "5_DOORLOCK_YALE_REAL_LIVING": "Press the Add button below.",
      "1_INSTEON_LED_BULB": "To link manually, unscrew the LED Bulb for a moment and reinsert it into the socket. Then click the Add button below.",
      "1_IKEA_TRADFRI_TUNABLE_WHITE": "Factory reset the product as follows:\nResting the light is power cycle quickly 6 times. Then press the Add Now button below.",
      "1_EVSE": "Quickly tap Push Button 13 times to factory reset (blue LED will blink rapidly when ready to join).",
      "2_EVSE": "Click Add Now button below.",
      "1_IOT8": "Quickly tap Push Button 13 times to factory reset (red LED will blink rapidly when ready to join).",
      "2_IOT8": "Click Add Now button below."
    },
    "WELCOME": {
      "1_TITLE": "Control your devices",
      "1_DESCRIPTION": "Easy and intuitive ways to control/monitor your devices. Dim the lights, Start Irrigation system, Lock the door, Turn off water heater.",
      "2_TITLE": "Device ecosystem",
      "2_DESCRIPTION": "Wide range of devices to help you control/monitor your lights, appliances, irrigation and more!",
      "3_TITLE": "Automation Rules",
      "3_DESCRIPTION": "Be creative and make your own rules. Create intelligent custom rules to automate your home. Lights come on at Sunset. Appliances turn off when not needed to save energy, Irrigation works based on your schedule."
    },
    "RESOURCES": {
      "QUICK_GUIDE": "Quick Start Guide",
      "BUY": "Buy",
      "USER_GUIDE": "User Guide",
      "INSTALATION_GUIDE": "Installation Guide",
      "GATEWAY_INSTRUCTIONS": "<ul><li>Connect Ethernet cable to Gateway.</li><li>Ensure that your mobile device and Gateway are connected to the same network.</li><li>Click continue and wait for about 30 secs</li><li>When gateway is discovered, \"Found 1 device\" is displayed</li></ul>"
    },
    "GENERAL": {
      "AFTER": "after",
      "AND": "and",
      "AT": "at",
      "BEFORE": "before",
      "BETWEEN": "between",
      "COLOR": "color",
      "DEVICE": "device",
      "DURING": "during",
      "EACH": "each",
      "EVERY": "every",
      "FOR": "for",
      "IN": "in",
      "ON": "on",
      "OR": "OR",
      "THE_1": "the",
      "THE_2": "the",
      "TO": "to",
      "WHEN": "when"
    },
    "COLORS": {
       "BLACK": "black",
       "BLUE": "blue",
       "GREEN": "green",
       "CYAN": "cyan",
       "VIOLET": "violet",
       "PURPLE": "purple",
       "GRAY": "gray",
       "BROWN": "brown",
       "SILVER": "silver",
       "RED": "red",
       "ROSE": "rose",
       "FUCHSIA": "fuchsia",
       "ORANGE": "orange",
       "GOLD": "gold",
       "YELLOW": "yellow",
       "WHITE": "white",
       "WARMWHITE": "warm white",
       "SOFTWHITE": "soft white",
       "DAYLIGHTWHITE": "daylight white",
       "COOLWHITE": "cool white"
    },
    "ORDINALS": {
      "FIRST": "st",
      "SECOND": "nd",
      "THIRD": "rd",
      "N": "th"
    },
    "AR": {
      "CONDITIONS": {
        "BATTERY": "Battery",
        "CLOSE_OPEN": "Close/Open",
        "CONSUMPTION": "Consumption",
        "COOLING_SETPOINT": "Cooling Setpoint",
        "COST": "Cost",
        "ENERGY": "Energy (kWh)",
        "HEATING_SETPOINT": "Heating Setpoint",
        "HUMIDITY": "Humidity",
        "LEAK_DETECTION": "Leak Detection",
        "LEVEL": "Level",
        "LOAD": "Load",
        "LOAD_1": "Load 1",
        "LOAD_2": "Load 2",
        "LOCK": "Lock",
        "MOTION": "Motion",
        "POWER": "Power (kW)",
        "SESSION": "Session",
        "SWITCH": "Switch",
        "SWITCHES": "Switches",
        "TEMPERATURE": "Temperature",
        "THERMOSTAT_MODE": "Thermostat Mode",
        "WARNING": "Warning",
        "BUTTON": "Button",
        "SMOKE": "Smoke",
        "STATUS": "Status",
        "CARBONMONO": "CO"
      },
      "CONDITIONS_NL": {
        "ALARMED": "Alarmed",
        "AUTO": "Auto",
        "BATTERY": "Battery",
        "BUTTON": "Button",
        "CHARGE_LEVEL": "Charge level",
        "CHARGER_STATUS": "Charger status",
        "CHARGING_SESSION": "Charging session",
        "COOL": "Cool",
        "COOLING_SETPOINT": "cooling setpoint",
        "CURRENT": "Current",
        "EMERGENCY_BUTTON": "Emergency button",
        "ENERGY": "Energy",
        "ENERGY_CONSUMPTION": "Energy consumption",
        "FAN": "fan",
        "FREQUENCY": "Frequency",
        "HEAT": "Heat",
        "HEAT_COOL": "Heat-Cool",
        "HEATING_SETPOINT": "heating setpoint",
        "HIGH": "High",
        "HUMIDITY": "Humidity",
        "IDLE": "Idle",
        "IS_ALARMED": "is Alarmed",
        "IS_CLOSED": "is Closed",
        "IS_OCCUPIED": "is Occupied",
        "IS_OFF": "is Off",
        "IS_ON": "is On",
        "IS_OPEN": "is Open",
        "IS_LOCKED": "is Locked",
        "IS_NOT_ALARMED": "is not Alarmed",
        "IS_UNOCCUPIED": "is Unoccupied",
        "IS_UNLOCKED": "is Unlocked",
        "LOW": "Low",
        "MEDIUM": "Medium",
        "MODE": "mode",
        "NOT_ALARMED": "Not Alarmed",
        "OFF": "Off",
        "ON": "On",
        "POWER": "Power",
        "PRESSURE": "Pressure",
        "PRESSED": "Pressed",
        "SMART": "Smart",
        "STATE": "state",
        "SWITCH_1": "Switch 1",
        "SWITCH_2": "Switch 2",
        "SWITCH_3": "Switch 3",
        "TEMPERATURE": "Temperature",
        "USAGE": "usage",
        "VOLTAGE": "Voltage",
        "WARNING_MODE": {
          "BURGLAR": "Burglar",
          "FIRE": "Fire",
          "PANIC": "Panic",
          "BELL": "Bell"
        }
      },
      "CONNECTORS": {
        "DETECTS": "detects",
        "EXCEEDS": "exceeds",
        "IS": "is",
        "IS_ABOVE": "is above",
        "IS_BELOW": "is below",
        "IS_DIFFERENT_FROM": "is different from",
        "IS_EQUAL_TO": "is equal to",
        "IS_GREATER_OR_EQUAL_TO": "is greater or equal to",
        "IS_LOWER_OR_EQUAL_TO": "is lower or equal to",
        "IS_PRESSED": "is pressed",
        "IS_PRESSED_ON": "is pressed on",
        "IS_SET_TO": "is set to",
        "IS_UNDER": "is under",
        "MATCHES": "matches",
        "RANDOMLY": "randomly",
        "SENDS_ALERT": "sends alert"
      },
      "EFFECTS": {
        "COLOR": "Color",
        "COOLING_SETPOINT": "Cooling Setpoint",
        "EMAIL": "Email",
        "HEATING_SETPOINT": "Heating Setpoint",
        "LEVEL": "Level",
        "LOAD": "Load",
        "LOAD_1": "Load 1",
        "LOAD_2": "Load 2",
        "LOCK": "Lock",
        "NOTIFICATION": "Notification",
        "PROGRAMS": "Programs",
        "SELECT_ACTION": "Select Action",
        "SELECT_PROGRAM": "Select Program",
        "SELECT_ZONE": "Select Zone",
        "SWITCH": "Switch",
        "THERMOSTAT_MODE": "Thermostat Mode",
        "WARNING": "Warning",
        "ZONES": "Zones"
      },
      "EFFECTS_NL": {
        "AFTER": "after",
        "EXECUTE": "execute",
        "EXECUTE_METHOD": "execute method",
        "LOCK": "Lock",
        "PROGRAM": "Program",
        "SEND_EMAIL": "Send Email",
        "SEND_PUSH_NOTIFICATION": "Send Push Notification",
        "SET": "set",
        "START_THE": "start the ",
        "SOUND_ON": "sound on ",
        "ON_THE": "on the",
        "START_CHARGING_SESSION": "Start charging session",
        "START_CHARGING_SESSION_IN": "Start charging session in",
        "STOP_CHARGING_SESSION_IN": "Stop charging session in",
        "START_WARNING": "Start Warning",
        "START_WARNING_ON": "Start warning on",
        "STOP_WARNING": "Stop Warning",
        "STOP_WARNING_ON": "Stop warning on",
        "TOGGLE": "Toggle",
        "TURN_ON": "turn On",
        "TURN_OFF": "turn Off",
        "UNLOCK": "Unlock",
        "ZONE": "Zone"
      },
      "STATES": {
        "CLOSED": "Closed",
        "CO": "CO",
        "CO_DETECTED": "CO Detected",
        "NO_CO": "No CO",
        "EMERGENCY": "emergency",
        "EMERGENCY_DETECTED": "Emergency Detected",
        "NO_EMERGENCY": "No Emergency",
        "FIRE": "Fire",
        "FIRE_DETECTED": "Fire Detected",
        "NO_FIRE": "No Fire",
        "GLASS_BREAK": "Glass break",
        "GLASS_BREAK_DETECTED": "Glass Break Detected",
        "NO_GLASS_BREAK": "No Glass break",
        "LEAK": "Leak",
        "LEAK_DETECTED": "Leak Detected",
        "NO_LEAK": "No Leak",
        "MOTION": "Motion",
        "NO_MOTION": "No Motion",
        "OPEN": "Open",
        "SMOKE": "Smoke",
        "NO_SMOKE": "No Smoke",
        "VIBRATION": "Vibration",
        "VIBRATION_DETECTED": "Vibration Detected",
        "NO_VIBRATION": "No Vibration",
        "WARNING": "warning",
        "WATER": "Water",
        "NO_WATER": "No Water"
      },
      "TIME": {
        "REPEATING_EVERY": "repeating every",
        "STARTING_ON": "starting on",
        "TIME_MATCHES": "time matches"
      }
    },
    "SCENES": {
      "CONTROLLERS": {
        "BUTTON_1": "Button 1",
        "BUTTON_2": "Button 2",
        "BUTTON_3": "Button 3"
      }
    },
    "TIME": {
      "DAYS": {
        "SUN": "Sun",
        "MON": "Mon",
        "TUE": "Tue",
        "WED": "Wed",
        "THU": "Thu",
        "FRI": "Fri",
        "SAT": "Sat"
      },
      "MONTHS": {
        "JANUARY": "January",
        "FEBRUARY": "February",
        "MARCH": "March",
        "APRIL": "April",
        "MAY": "May",
        "JUNE": "June",
        "JULY": "July",
        "AUGUST": "August",
        "SEPTEMBER": "September",
        "OCTOBER": "October",
        "NOVEMBER": "November",
        "DECEMBER": "December"
      },
      "FRACTIONS": {
        "DAY": "day",
        "DAYS": "days",
        "HR": "hr",
        "HRS": "hrs",
        "HOUR": "hour",
        "HOURS": "hours",
        "MIN": "min",
        "MINS": "mins",
        "MINUTE": "minute",
        "MINUTES": "minutes",
        "SEC": "sec",
        "SECS": "secs"
      },
      "PERIODS": {
        "AT": "at",
        "AT_HOUR": "at",
        "DAY_OF_THE_MONTH": "day of the month",
        "ON_EVEN_DATES": "on even dates",
        "ON_ODD_DATES": "on odd dates",
        "ON_WEEKDAYS": "on weekdays",
        "ON_WEEKENDS": "on weekends",
        "EVERY": "every",
        "EVERY_DAY": "every day",
        "EVERY_HOUR": "every hour",
        "HOURLY": "hourly",
        "SUNRISE": "sunrise",
        "SUNSET": "sunset",
        "TODAY": "Today"
      }
    },
    "DEVICES": {
      "EVSE": {
        "FAULTS": {
          "DEFAULT": "There was an unexpected error with your device.",
          "METER_FAILURE": "Internal device error is preventing to obtain electrical measurements.",
          "OVER_VOLTAGE": "Input voltage level is too high.",
          "UNDER_VOLTAGE": "Input voltage level is too low.",
          "OVER_CURRENT": "Detected charging current higher than supported by charger.",
          "CONTACT_WET_FAILURE": "Detected voltage on charging pins even with the relays disabled.",
          "CONTACT_DRY_FAILURE": "Detected absence of voltage after enabling relays.",
          "GROUND_FAULT": "Unbalanced current supply.",
          "PILOT_SHORT_CIRCUIT": "Pilot signal amplitude short circuited to ground.",
          "WRONG_POWER_SUPPLY": "Could not determine proper power supply level."
        },
        "STATUS": {
          "CHARGING": "Charging",
          "CHARGED": "Charged",
          "FAULT": "Fault",
          "NOT_CHARGING": "Not Charging",
          "PLUGGED": "Plugged",
          "READY": "Ready",
          "UNKNOWN": "Unknown",
          "UNPLUGGED": "Unplugged"
        },
        "LABELS": {
          "AUTO_START": "Auto-start mode",
          "BATTERY_CAPACITY": "Battery capacity",
          "CAR_MODEL": "Car model",
          "CHARGE_LEVEL": "Charge level",
          "CURRENT": "Current",
          "DETAILS": "Details",
          "ELECTRIC_RANGE": "Electric range",
          "ENERGY": "Energy",
          "FULL_CHARGE_AT": "Full charge at",
          "GENERAL": "General",
          "LEFT": "left",
          "POWER": "Power",
          "SESSION": "Session",
          "SESSION_COST": "Session cost",
          "SESSION_TIME": "Session time",
          "STOP": "Stop",
          "TIME": "Time",
          "VOLTAGE": "Voltage"
        },
        "TEXTS": {
          "CONFIRM_DELETE_STOP_SCHEDULE": "Are you sure you want to remove this schedule?",
          "NO_SESSIONS": "No charging sessions found for this device.",
          "NO_UPCOMING_SESSIONS": "You have no upcoming sessions. Go to automation rules to schedule a new one!",
          "OVERALL_ENERGY_CONSUMPTION": "Overall energy consumption",
          "RECEIVE_NOTIFICATION": "Receive notification?",
          "SCHEDULE_STOP": "Schedule stop",
          "SESSION_HISTORY": "Session History",
          "STOP_CHARGING_WHEN": "Stop charging when...",
          "STOP_SESSION_NOTI_SUBJECT": "Charging session stopped",
          "STOP_SESSION_NOTI_TEXT": "Your {{deviceName}} charging session #{{sessionId}} has stopped",
          "STOP_SESSION_SCHEDULE_ERROR": "There has been a problem scheduling the stopping of your charging session",
          "UPCOMING_SESSIONS": "Upcoming Sessions"
        },
        "WALKTHROUGHS": {
          "HELP": {
            "STEP_1": {
              "TITLE": "EV Charging station",
              "CONTENT": "We'll guide you through the different things that you can do with your EV charging station."
            },
            "STEP_2": {
              "CONTENT": "Inside this area you can see the current status of your device (unplugged, plugged, charging, charged and fault) and additional information like the current charge level."
            },
            "STEP_3": {
              "CONTENT": "Move this slider to set the initial charge level of your battery. With this information, we can give you estimations of remaining charge time and total distance availability."
            },
            "STEP_4": {
              "CONTENT": "With this button you can start or stop a new charging session."
            },
            "STEP_5": {
              "CONTENT": "Tap this option to see more details of your device."
            },
            "STEP_6": {
              "CONTENT": "From here, you can see more information of your charging station, including:<br/><strong>Session:</strong> In this tab, you can see your upcoming sessions in plugged in mode, or more advanced information while charging your device like remaining time and session cost.<br/><strong>Details:</strong> The technical details of your device, like current and voltage."
            },
            "STEP_7": {
              "CONTENT": "To see more details and settings of this device you can tap the details button. In there, you can:<ul><li>Change the name and image of your device.</li><li>View historic information of your charging sessions.</li><li>Modify the device settings such as current limits and the model of your car.</li></ul><strong>Note:</strong> If you want to see time and distance estimations, you have to set your car model or set your technical details manually."
            }
          }
        }
      }
    },
    "ERRORS": {
      "DEFAULT_ERROR": "Sorry it appears something went wrong, please try again. If issues persist let us know and we will look into it.",
      "AUTH": {
        "INVALID_EMAIL": "Email is invalid",
        "INVALID_USER_CREDENTIALS": "Either the email or password is incorrect, please check and try again",
        "LOGIN_ATTEMPTS_EXCEEDED": "Number of login attempts exceeded",
        "PASSWORD_SPECIAL_CHARACTER": "Password must contain at least one symbol",
        "PASSWORD_SPECIAL_CHARACTER_DESC": "One symbol",
        "PASSWORD_REQUIRED": "Password is required",
        "USER_PASS_REQUIRED": "Username and password are required"
      },
      "SIGN_UP": {
        "ALREADY_REGISTERED": "You already have an account! Click Sign In below to continue",
        "DEFAULT_ERROR": "Error creating your account, please try again",
        "PASSWORD_LOWERCASE": "Password must contain at least one lowercase character",
        "PASSWORD_LOWERCASE_DESC": "One lowercase character",
        "PASSWORD_MIN_LENGTH": "Password must be at least 8 characters",
        "PASSWORD_MIN_LENGTH_DESC": "8 characters",
        "PASSWORD_NOT_MATCH": "Passwords do not match",
        "PASSWORD_NUMBER": "Password must contain at least one number",
        "PASSWORD_NUMBER_DESC": "One number",
        "PASSWORD_UPPERCASE": "Password must contain at least one uppercase character",
        "PASSWORD_UPPERCASE_DESC": "One uppercase character"
      },
      "SIGN_IN": {
        "DEFAULT_ERROR": "Error signing in",
        "PASSWORD_LOWERCASE": "Password does not have any lowercase character",
        "PASSWORD_MIN_LENGTH": "Password is less than 9 characters",
        "PASSWORD_NUMBER": "Password does not have any number",
        "PASSWORD_UPPERCASE": "Password does not have any uppercase character"
      },
      "FORGOT_PASS": {
        "DEFAULT_ERROR": "Sorry. We don't have an account for this email. Please check for typos and try again.",
        "EMAIL_FAILURE": "Sorry something went wrong on our end. Please try again or contact support if you get this error again.",
        "EXTERNAL_ACCOUNT": "You have created an account using {{provider}}, please use {{provider}} login to continue"
      }
    },
    "WALKTHROUGHS": {
      "AREAS_HELP": {
        "STEP_1": {
          "TITLE": "Areas",
          "CONTENT": "You can group devices inside a location by using areas. Here you can add, remove and associate devices to them."
        },
        "STEP_2": {
          "CONTENT": "Tap on this button to add new areas."
        },
        "STEP_3": {
          "CONTENT": "Search your areas by their names."
        },
        "STEP_4": {
          "CONTENT": "Tap on one area to see its details and modify its devices."
        }
      },
      "DASHBOARD_HELP": {
        "STEP_1": {
          "TITLE": "Dashboard",
          "CONTENT": "This is the dashboard, one of the main sections within the app. We'll give you an overview of what you can do from here."
        },
        "STEP_2": {
          "CONTENT": "Add new resources, like devices, areas, automation rules or scenes."
        },
        "STEP_3": {
          "CONTENT": "This is your current selected location"
        },
        "STEP_4": {
          "CONTENT": "You can control and monitor all your devices from here, and even you can filter them by area."
        },
        "STEP_5": {
          "TITLE": "Events",
          "CONTENT": "Here you can see the list of events related to the interactions and the state of your devices."
        },
        "STEP_6": {
          "TITLE": "Scenes",
          "CONTENT": "From here you can manipulate all the scenes you have created."
        },
        "STEP_7": {
          "TITLE": "That's all!",
          "CONTENT": "You can use the left menu to navigate to other sections in the app. If you want to see this help again, use the help button in the top menu."
        }
      },
      "DASHBOARD_WELCOME": {
        "STEP_1": {
          "TITLE": "Welcome!",
          "CONTENT": "We'll help you add your first device, when you are ready click on the arrows below or skip this guide if you want."
        },
        "STEP_2": {
          "CONTENT": "Tap the add button"
        },
        "STEP_3": {
          "CONTENT": "Tap on Devices"
        }
      },
      "DASHBOARD_WELCOME_RETURN": {
        "STEP_1": {
          "CONTENT": "Your added devices will appear here, and in the devices list, where you can control and monitor them."
        }
      },
      "DEVICES_HELP": {
        "STEP_1": {
          "TITLE": "Devices",
          "CONTENT": "Like in the dashboard, here you can control, monitor, edit and remove all your devices."
        },
        "STEP_2": {
          "CONTENT": "Tap on this button to add new devices."
        },
        "STEP_3": {
          "CONTENT": "Search your devices by their names."
        },
        "STEP_4": {
          "CONTENT": "Filter devices by area."
        },
        "STEP_5": {
          "CONTENT": "Display all hidden devices, like the messenger."
        },
        "STEP_6": {
          "CONTENT": "This represents the currrent state of the device:<ul><li class='online'>Online</li><li class='processing'>Processing</li><li class='offline'>Offline or with errors</li>"
        },
        "STEP_7": {
          "CONTENT": "Go to the details of the device, where you can change its name and image, add it to an area and much more."
        }
      },
      "DISCOVER_DEVICES_HELP": {
        "STEP_1": {
          "TITLE": "Discover Devices",
          "CONTENT": "From here you can add and discover new devices, consult their user guides and purchase them too."
        },
        "STEP_2": {
          "CONTENT": "While you are in this section, the app will try to discover devices automatically and let you know when it as found something."
        },
        "STEP_3": {
          "CONTENT": "These are the list of categories for the different devices supported within the app. You can use them to learn more about devices and add them manually."
        }
      },
      "DISCOVER_DEVICES_WELCOME": {
        "STEP_1": {
          "CONTENT": "The app is finding devices, please wait for a few seconds... You can also add devices by selecting the corresponding category from the list."
        },
        "STEP_2": {
          "CONTENT": "We have found a device, please tap in this section."
        },
        "STEP_3": {
          "CONTENT": "This is the list of discovered devices. Check the devices you want to add and tap on the Done button below."
        },
        "STEP_4": {
          "CONTENT": "From here, you can add other devices, or you can go to the dashboard to start using them!"
        }
      },
      "LOCATIONS_HELP": {
        "STEP_1": {
          "TITLE": "Locations",
          "CONTENT": "You can manage all your physical locations in this section, including their information, settings and energy."
        },
        "STEP_2": {
          "CONTENT": "Tap on this button to add new locations."
        },
        "STEP_3": {
          "CONTENT": "Search your locations by their names."
        },
        "STEP_4": {
          "CONTENT": "Tap on this button to see the location options."
        },
        "STEP_5": {
          "CONTENT": "Manage your location using these options."
        }
      },
      "MICROAPPS_HELP": {
        "STEP_1": {
          "TITLE": "Micro Apps",
          "CONTENT": "The micro apps allow you to control devices centrally to support specific scenarios of use in your daily life. In this section you can create new micro apps, remove them, associate devices to them and configure actions to notify you when something happen."
        },
        "STEP_2": {
          "CONTENT": "Tap on this button to add new micro apps."
        },
        "STEP_3": {
          "CONTENT": "Search your micro apps by their names."
        },
        "STEP_4": {
          "CONTENT": "Tap on this button to see the microapp options."
        },
        "STEP_5": {
          "CONTENT": "Manage your microapp using these options."
        }
      }
    }
  },
  "es": {
    "PAGE_TITLE": {
      "ABOUT": "Acerca de",
      "AUTOMATION_RULES": "Reglas de automatización",
      "AREAS": "Áreas",
      "DASHBOARD": "Dashboard",
      "DEVICES": "Dispositivos",
      "LOCATIONS": "Ubicaciones",
      "MICROAPPS": "Micro Apps",
      "RAINBEE_DETAILS": "Detalles del Rainbee",
      "SCENES": "Escenas",
      "SECURITY_PANEL": "Panel de Seguridad",
      "SHOP": "Tienda",
      "SIGN_IN": "¡Ingresa!",
      "SIGN_UP": "¡Regístrate!",
      "SUPPORT": "Soporte"
    },
    "BUTTON": {
      "AREAS_BELONG": "Áreas a las que pertenece",
      "CANCEL": "Cancelar",
      "CHANGES": "Cambios",
      "CLEAR": "Limpiar",
      "CONFIRM": "Confirmar",
      "CONNECT": "Conectar",
      "CONTINUE": "Continuar",
      "CREATE_ACCOUNT": "Crear Cuenta",
      "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
      "LEARN_MORE": "Aprende más",
      "LOGOUT": "Cerrar sesión",
      "NEXT": "Siguiente",
      "NO": "No",
      "OK": "OK",
      "RECOVER_PASSWORD": "Recuperar Contraseña",
      "REFRESH": "Actualizar",
      "RETRY_NOW": "Reintentar",
      "SAVE": "Guardar",
      "SET_BUTTON": "Botón \"Set\"",
      "SIGN_IN": "Ingresa",
      "SIGN_UP": "Regístrate",
      "USE_ID": "Usar ID",
      "VIEW_ALL": "Ver Todo",
      "YES": "Si"
    },
    "LABEL": {
      "ABOVE": "Encima",
      "ACCOUNTS": "Cuentas",
      "ACTION": "Acción",
      "ACTIVE": "Active",
      "ADD": "Agregar",
      "ADD_ANOTHER_DEVICE": "Agregar otro dispositivo >",
      "ADD_DIFFERENT_DEVICE": "Agregar un dispositivo diferente >",
      "ADD_NOW": "Agregar ahora",
      "ADD_TO_AREA": "Agregar a otra área",
      "ADD_TO_NEXT_AREA": "Agregar a la siguiente área",
      "ADD_DEVICE": "Agregar nuevo dispositivo",
      "ADD_DEVICES": "Agregar dispositivos",
      "ADDED_TO": "agregado a",
      "AFTER": "Después del",
      "ALL": "todas",
      "ALL_DEVICES": "Todos los Dispositivos",
      "ANALOG": "Análogo",
      "ANY": "alguna",
      "AREA": "Área",
      "AT": "En el",
      "AUTOMATION_RULE": "Regla de Automatización",
      "BEFORE": "Antes del",
      "BILLING_CYCLE": "Ciclo de facturación",
      "BELOW": "Debajo",
      "BUTTON": "Botón",
      "CEILING": "Techo",
      "CHANGE": "Cambiar",
      "CHANGE_COLOR": "Cambiar Color",
      "CHANGE_LOCATION": "Cambiar Ubicación",
      "CLOSE": "Cerrar",
      "COLOR": "Color",
      "CONDITION": "Condición",
      "CONDITION_MET": "condicion se cumpla:",
      "CONDITIONS_MET": "las condiciones se cumplan:",
      "CONFIRM": "Confirmar",
      "CONFIRM_DELETE": "Confirmar borrado",
      "CONTINUE_DASHBOARD": "Continuar al Dashboard",
      "CONTROL_PATH": "Ruta del control",
      "CONTROLLER": "Controlador",
      "CONTROLLERS": "Controladores",
      "COST": "Costo",
      "CURRENCY": "Moneda",
      "CURRENT_PASSWORD": "Contraseña actual",
      "CUSTOM": "Personalizado",
      "CYCLE": "Ciclo",
      "DAY": "Día",
      "DAYS": "Días",
      "DELAY": "Retraso",
      "DELETE": "Borrar",
      "DELETED": "Borrado",
      "DETAILS": "Detalles",
      "DEVICE": "Dispositivo",
      "DEVICE_ADDED": "Dispositivo agregado",
      "DEVICES": "Dispositivos",
      "DEVICE_STATUS": "Estado del dispositivo",
      "DIGITAL": "Digital",
      "DISABLE": "Deshabilitar",
      "DISTANCE": "Distancia",
      "DO": "hacer",
      "DONE": "Listo",
      "DURATION": "Duración",
      "EDIT": "Editar",
      "EDIT_INFO": "Editar Información",
      "EDIT_SUB_DEVICE_NAME": "Editar Nombre del Sub-Dispositivo",
      "EFFECT": "Efecto",
      "EMAIL": "Email",
      "ENABLE": "Habilitar",
      "ENERGY": "Energía",
      "ENERGY_COST_BILLING_CYCLE": "Ciclo de Facturación de Costos Energéticos",
      "ENERGY_COST_SETUP": "Configuración de Costos Energéticos",
      "ENERGY_COST_STRUCTURE": "Estructura de costos energéticos",
      "ENERGY_MANAGEMENT": "Energía",
      "ENERGY_USAGE": "Uso energético",
      "EVEN_DATES": " Pares",
      "EVENTS": "Eventos",
      "EVERYDAY": "Cada día",
      "FIND_DEVICE": "Buscando Dispositivos...",
      "FIRMWARE": "Firmware",
      "FIXED_TIME": "Tiempo Fijo",
      "FOUND": "Encontró",
      "GENERAL_SETTINGS": "Configuraciones Generales",
      "GO_TO_DASHBOARD": "Ir al Dashboard",
      "HARDWARE": "Hardware",
      "HISTORY": "Historial",
      "HONEYWELL_DEVICES": "Dispositivos Honeywell",
      "HOUR": "Hora",
      "HOURS": "horas",
      "HOURSM": "Horas",
      "HOUSE_CODE": "Código hogar",
      "HUB_NEEDED": "Se requiere un Hub!",
      "IMAGE_PATH": "Ruta de la imagen",
      "IN": "en",
      "INI_WEEK": "S",
      "INI_YEAR": "A",
      "INPUT": "Entrada",
      "INPUT_DEVICE": "Dispositivo de entrada",
      "INPUTS": "Entradas",
      "INTERFACE_NEEDED": "Se requiere una Interfaz!",
      "INTERVAL_TIME": "Intervalo de tiempo",
      "IP_ADDRESS": "Dirección IP",
      "KILOMETERS": "Kilómetros",
      "LANGUAGE": "Idioma",
      "LAST_NAME": "Apellido",
      "LOAD_MORE": "Mostrar más...",
      "LOADING": "Cargando",
      "LOCATION": "Ubicación",
      "LOCATION_ADDED": "Ubicación Agregada",
      "LOCATION_INFO": "Información de la ubicación",
      "LOCATION_SETTINGS": "Configuraciones de la ubicación",
      "LOWER": "Inferior",
      "MAC": "MAC",
      "MESSAGE": "Mensaje",
      "METRIC_UNITS": "Unidades",
      "MICROAPP": "Micro App",
      "MILES": "Millas",
      "MINUTE": "Min",
      "MINUTES": "Minutos",
      "MONTHS": "Meses",
      "MORE_THAN": "Más que",
      "MY_LOCATION_NAME": "Nombre de mi ubicación",
      "MY_LOCATION_ZIP": "Código postal de mi ubicación",
      "MY_LOCATION_ADDRESS": "Dirección de mi ubicación (opcional)",
      "MY_MICROAPP_NAME": "Nombre de mi micro app",
      "NAME": "Nombre",
      "NEST_DEVICES": "Dispositivos Nest",
      "NEW": "Nueva",
      "NO": "No",
      "NO_RECENT": "Nada recientemente ...",
      "NOT_FOUND": "No encontrado",
      "ODD_DATES": "Impares",
      "OFF": "Apagado",
      "ON": "Encendido",
      "OPTION": "Opción",
      "OUTPUTS": "Salidas",
      "PAIRING": "Emparejamiento",
      "PAIRINGS": "Emparejamientos",
      "PASSWORD": "Contraseña",
      "PERFECT": "Perfecto",
      "PHONE": "Número de Teléfono",
      "PORT": "Puerto",
      "PRICE": "Precio",
      "PRICES": "Precios",
      "PRIVACY_POLICY": "Política de Privacidad",
      "PROFILE": "Perfil",
      "PROGRAM_NAME:": "Nombre del programa",
      "RANDOM_TIME": "Tiempo aleatorio",
      "RANGE": "Rango",
      "READY_ADD": "¿Listo para agregar?",
      "REMOVE": "Eliminar",
      "REMOVED_FROM": "removido de",
      "RESPONDER": "Respuesta",
      "RETRY": "Reintentar",
      "RETRYING": "Reintentando",
      "RULE": "Regla",
      "RULE_NAME": "Nombre de la regla",
      "SAVING": "Guardando",
      "SCENE": "Escena",
      "SCENE_CONTROLLER_NEEDED": "Se requiere un Controlador de escenas!",
      "SCENE_NAME": "Nombre de la escena",
      "SCENE_RESPONSE": "Grupo de respuestas de la escena",
      "SCHEDULE": "Horario",
      "SCHEDULE_NAME": "Nombre del horario",
      "SEARCH": "Buscar",
      "SECOND": "Seg",
      "SETTINGS": "Configuraciones",
      "SETUP": "Configurar",
      "SKIP": "Omitir",
      "SLOGAN": "Life. Simplified!",
      "SLOT": "Slot",
      "SLOTS": "Slots",
      "SNAPSHOT_PORT": "Puerto de la instantánea",
      "SOFTWARE": "Software",
      "STANDARD": "Estándar",
      "START_TIMES": "Horas de Inicio",
      "SUBJECT": "Asunto",
      "SUMMARY": "Resumen",
      "SUNRISE": "Amanecer",
      "SUNSET": "Atardecer",
      "TEMPERATURE_UNITS": "Unidades de Temperatura",
      "TERMS_AND_CONDITIONS": "Términos y Condiciones",
      "THE_AREA": "el Área",
      "THE_DEVICE": "el Dispositivo",
      "THE_FOLLOWING": "lo siguiente:",
      "THE_LOCATION": "la Ubicación",
      "THE_ZONES": "todas las zonas",
      "THEN": "Entonces",
      "THESE_DAYS": "Éstos días",
      "THIS_PROGRAM": "este programa",
      "THIS_TIME": "Ésta hora",
      "TIER": "Nivel",
      "TIERED": "Niveles",
      "TIME_OF_USE": "Tiempo de Uso",
      "UNIT_CODE": "Código unitario",
      "UPPER": "Superior",
      "USERNAME": "Nombre de usuario",
      "VERSION": "Versión",
      "VIEW_LESS": "Ver menos",
      "VIEW_MORE": "Ver más",
      "WARNING": "Advertencia",
      "WATERING_DAYS": "Días de irrigación",
      "WE_FOUND": "We found",
      "WHEN": "Cuando",
      "WINDOW_TIME": "Ventana de tiempo",
      "YOU_CAN_ADD": "que puedes agregar",
      "YOUR_PROFILE": "Tu Perfil",
      "ZONE_TIMERS": "Temporizadores de las Zonas",
      "ZONES_LIST": "Lista de Zonas"
    },
    "DAYS": {
      "MONDAY": "Lunes",
      "TUESDAY": "Martes",
      "WEDNESDAY": "Miércoles",
      "THURSDAY": "Jueves",
      "FRIDAY": "Viernes",
      "SATURDAY": "Sábado",
      "SUNDAY": "Domingo"
    },
    "MONTHS": {
      "JANUARY": "Ene",
      "FEBRUARY": "Feb",
      "MARCH": "Mar",
      "APRIL": "Abr",
      "MAY": "May",
      "JUNE": "Jun",
      "JULY": "Jul",
      "AUGUST": "Ago",
      "SEPTEMBER": "Sep",
      "OCTOBER": "Oct",
      "NOVEMBER": "Nov",
      "DECEMBER": "Dic"
    },
    "TEXT": {
      "ACCOUNT_ALREADY_EXISTS": "La cuenta ya existe",
      "ACCOUNT_DELETE_CONFIRMATION": "¿Deseas eliminar esta cuenta? Los dispositivos asociados a esta cuenta serán eliminados",
      "ACCOUNT_DELETE_ERROR": "Lo sentimos, ha ocurrido un error al desvincular la cuenta.",
      "ACCOUNT_DELETE_SUCCESS": "La cuenta ha sido desvinculada de forma exitosa",
      "ACTIONS_EXPLANATION_TEXT": "Las Acciones son la parte de tus Reglas que suceden una vez tus condiciones están cumplidas.",
      "ADD_CONDITION_TO": "Agregando condición en",
      "ADD_DEVICES": "+ Agregar Dispositivos",
      "ADD_EFFECT_TO": "Agregando efecto en",
      "ADD_GATEWAY_STEP": "Este gateway puede conectarse vía Ethernet y WiFi. Haz click en el botón Agregar y te guiaremos con la instalación.",
      "ADD_GATEWAY_STEP_RES": "Haz click en el botón Agregar ahora cuando estés listo y te guiaremos con la instalación.",
      "ADD_RESPONDER_TO": "Agregando respuesta en",
      "ADD_RULES": "Haz click en el botón + ubicado en la parte superior derecha para empezar a crear Reglas de Automatización!",
      "ADD_SCENE_TEXT": "Haz click en el botón + ubicado en la parte superior derecha para empezar a crear escenas!",
      "ADD_MICROAPPS": "Haz click en el botón + ubicado en la parte superior derecha para crear y configurar tu primera Micro App!",
      "ADDING_YOUR": "Agregando tu",
      "ADDRESS": "Dirección",
      "ALL_RIGHTS_RESERVED": "Todos los derechos reservados",
      "APP_DESCRIPTION": "Smartenit te ayuda a monitorear y controlar tu uso de energía y\nagua, administrar la iluminación, mejorar tu comodidad, y\nmás!",
      "AREA_DELETE_CONFIRMATION": "¿Deseas eliminar esta área?",
      "BELOW_FACTORY_RESET": " abajo para reestablecer los valores de fábrica y presiona el botón Reintentar. O regresa al Dashboard.",
      "BY_SIGNING_UP": "Al registrarte, aceptas los",
      "CHANGE_LOCATION": "Cambiar ubicación",
      "CHANGE_LOCATION_DESCRIPTION": "Selecciona la ubicación a la cual quieres mover este gateway y sus dispositivos",
      "CLOSER_ROUTER_WIFI": "más cerca a tu router WiFi",
      "COME_BACK_WIFI": "Regresa a esta pantalla. Si la conexión a la red es exitosa, entonces verás una lista de redes WiFi cercanas",
      "CONDITIONS_EXPLANATION_TEXT": "Las Condiciones son la parte de tus Reglas, que necesitan suceder para activar tus acciones.",
      "CONNECTION_ERROR": "Error de conexión",
      "CONNECTION_ERROR_GW": "Hubo un error conectandose a tu gateway, ¿deseas intentar nuevamente?",
      "CONNECT_WIFI_NETWORK": "Conecta tu red WiFi",
      "CONNECT_YOUR": "Conecta tu gateway",
      "CONNECTED_SUCCESS": "conectado éxitosamente!",
      "CONFIGURE_CONTROLLER_FOR": "Configurando controlador para",
      "CONFIRM": "¿Estás seguro?",
      "CONFIRM_DELETE": "¿Deseas eliminar esta entrada?",
      "CONFIRM_DELETE_CONDITION": "¿Deseas eliminar esta condición?",
      "CONFIRM_DELETE_EFFECT": "¿Deseas eliminar este efecto?",
      "CONFIRM_DELETE_LOCATION": "¿Deseas eliminar esta ubicación?",
      "CONFIRM_DELETE_MICROAPP": "¿Deseas eliminar esta micro app?",
      "CONFIRM_DELETE_RULE": "¿Deseas eliminar esta regla?",
      "CONFIRM_DELETE_SCENE": "¿Deseas eliminar esta escena?",
      "CREATE_NEW_AREA": "Haz clic en el botón + ubicado en la parte superior derecha para empezar a crear áreas!",
      "CONTINUE_ADDING_DEVICES": "Seguir agregargando dispositivos",
      "DELETE_DEVICES_QUESTION": "¿Deseas eliminar todos los dispositivos de este gateway?",
      "DEVICE_DELETE_CONFIRMATION": "Estás seguro de eliminar este dispositivo de forma permanente?",
      "DISCOVERY_DEVICES_WARNING_1": "Tu gateway parece tener un problema, por favor reinícialo.",
      "DISCOVERY_DEVICES_WARNING_2": "Tu gateway está offline, por favor verifica la conexión a internet o reinícialo.",
      "DURATION_SIREN_VALIDATION": "La duración de la alarma debe ser igual o mayor a 1 segundo",
      "EM_SLOTS_ASSOCIATED_WITH_PRICE": "Hay slots asociados a este precio",
      "EM_TIER_RANGE_CONFLICT": "Este rango del nivel está en conflicto con",
      "EM_TIME_RANGE_SEPARATION": "El tiempo superior debe ser mayor al inferior al menos",
      "EM_TIME_RANGE_SLOT_CONFLICT": "Este rango de tiempo está en conflicto con el slot",
      "ENERGY_COST_BILLING_CYCLE": "El periodo de facturación empieza el",
      "ENERGY_COST_BILLING_CYCLE_DESC": "Por favor ingresa el dia de inicio de tu periodo de facturación. \n\nPor ejemplo: Si tu periodo de facturación es del 5 de Agosto al 5 de Septiembre, entonces ingresa 5 a continuación.\n",
      "ENTER_ADDRESS_OR_MAP_OR_ZIP": "Ingresa una dirección, o, si la geolocalización está habilitada, encuentrala en el mapa de abajo o ingresa sólo el código postal",
      "ENTER_WIFI_PASSWORD": "Ingresa la contraseña del Wifi para",
      "ERROR_AUTORULE_NAME": "Por favor ingresa un nombre válido para la Regla de Automatización",
      "ERROR_CONFIRM_PASS": "Por favor ingresa una nueva contraseña",
      "ERROR_CREATING_DEVICE": "Error creando el dispositivo, por favor inténtalo nuevamente",
      "ERROR_CURRENCY": "Por favor selecciona la moneda",
      "ERROR_EFFECT_OBJECT": "El Objeto Efecto no fue creado correctamente",
      "ERROR_GATEWAY_ACTION": "El objecto Acción no fue creado correctamente",
      "ERROR_GATEWAY_CONDITIONS": "Tu Gateway no soporta condiciones basadas en tiempo",
      "ERROR_GATEWAY_GET_PROCESSOR": "El objecto Gateway no soporta la función getProcessor",
      "ERROR_HOUSE_CODE": "El código de hogar es inválido, un código de hogar es un caracter que está en el rango A - P",
      "ERROR_IP_ADDRESS": "La dirección IP es incorrecta, ",
      "ERROR_LANGUAGE": "Por favor selecciona el idioma",
      "ERROR_LAST_NAME": "Por favor ingresa tu Apellido",
      "ERROR_MATCH_PASS": "Las contraseñas no coinciden, por favor inténtalo de nuevo",
      "ERROR_NAME": "Por favor ingresa tu Nombre",
      "ERROR_NEW_PASS": "Por favor ingresa tu nueva contraseña",
      "ERROR_OLD_PASS": "Por favor ingresa tu contraseña actual",
      "ERROR_PORT": "El puerto es incorrecto,",
      "ERROR_REMOVING_DEVICES": "Ocurrió un error al eliminar los dispositivos, por favor intenta nuevamente",
      "ERROR_REMOVING_GATEWAY": "Ocurrió un error al eliminar el gateway, por favor intenta nuevamente",
      "ERROR_SAVING_DEVICE": "Ocurrió un error al guardar el dispositivo. Por favor asegúrate de que las credenciales ingresadas eran correctas",
      "ERROR_SCENE_NAME": "Por favor ingresa un nombre de Escena válido",
      "ERROR_START_TIME_CONDITION": "La condición de fechas de inicio no fue creada correctamente",
      "ERROR_TEMPERATURE": "Por favor selecciona la unidad de temperatura",
      "ERROR_UNIT_CODE": "El código unitario es inválido, un código unitario es un número que está en el rango 1 - 16",
      "ERROR_WATERING": "La condición de días de irrigamiento no fue creada correctamente",
      "FIXED_TIME_SELECTED": "Tiempo fijo seleccionado",
      "FORGOT_PASS_SUCCESS": "¡Éxito! Por favor verifica tu email para restablecer tu contraseña.",
      "GATEWAY_HUB_NEEDED": "Este dispositivo requiere un Gateway/ Hub para poder ser agregado",
      "GATEWAY_PHONE": "Asegúrate de que tu teléfono esté en la misma red",
      "GATEWAY_WITH_PROTOCOLE": "<ul><li>El Gateway está ahora en modo emparejamiento, el dispositivo debe unirse automáticamente</li><li>Haz click en continuar para regresar a la página Descubrir, si tu dispositivo se empareja, entonces verás: \"1 Dispositivo encontrado\"</li></ul>",
      "GATEWAY_WITHOUT_INSTEON": "Tu Gateway no tiene una interface Insteon para agregar este dispositivo. Por favor, contacta con soporte para obtener detalles adicionales",
      "GATEWAY_WITHOUT_X10": "Tu Gateway no tiene una interface X10 para agregar este dispositivo. Por favor, contacta con soporte para obtener detalles adicionales",
      "GATEWAY_WITHOUT_ZIGBEE": "Tu Gateway no tiene una interface Zigbee para agregar este dispositivo. Por favor, contacta con soporte para obtener detalles adicionales",
      "HONEYWELL_ADD_DEVICE_ERROR": "Hubo un problema agregando uno o más dispositivos Honeywell, por favor intenta nuevamente",
      "HONEYWELL_CONNECT_TITLE": "Conectarse a Honeywell",
      "HONEYWELL_CONNECT_DESCRIPTION": "Para agregar e interactuar con dispositivos Honeywell, por favor conéctate a tu cuenta de Honeywell",
      "HONEYWELL_CONNECT_ERROR": "Hubo un error conectándose a tu cuenta de Honeywell, por favor intenta nuevamente",
      "HONEYWELL_GET_DEVICES_ERROR": "Hubo un problema obteniendo tus dispositivos Honeywell",
      "HONEYWELL_NO_DEVICES": "No se encontraron dispositivos Honeywell en tu cuenta",
      "IMAGE_SOURCE": "Selecciona una Imagen",
      "INFO_ADD_DEVICES": "Haz click en el botón continuar para ir a la página de Agregar Dispositivos. En la página Agregar Dispositivos, haz click en la ficha Dispositivos encontrados en la parte superior de la página, para terminar de agregar tu nuevo dispositivo.",
      "INSTEON_ADD_ERROR": "Hubo un error agregando tu dispositivo Insteon, por favor intenta nuevamente",
      "INSTEON_ADD_INSTRUCTIONS": "¿Qué opción quieres usar para agregar este dispositivo Insteon?",
      "INSTEON_ADD_INVALID_ID": "Este ID es inválido, asegúrate de que tenga 6 caracteres, ya sean números o letras",
      "INSTEON_PRESS_HOLD": "Mantén presionado el botón \"set\" del dispositivo para agregar el",
      "INTERVAL_TIME_SELECTED": "Intervalo de tiempo seleccionado.",
      "INVALID_DEVICE": "Hubo un problema agregando el dispositivo %deviceMac%\n. Por favor, reiniciálo de fábrica e intenta nuevamente.",
      "LEAST_ONE_LOCATION": "Debes de tener por lo menos una ubicación",
      "LETS_CONNECT": "Vamos a conectar el (la)",
      "LINKING_MODE": "dentro del modo enlace.",
      "LOAD_GALLERY": "Cargar desde la Galería",
      "LOCATION_ADDRESS_INFO": "La dirección de esta ubicación nos ayuda a proporcionarle características como GeoFencing, Microclimate y más. Esto es opcional.",
      "LOCATION_ADDRESS_TITLE": "Dirección de ubicación",
      "MICROAPPS_DOORBELL_TRIGGER_DEVICES_INTRO": "Por favor selecciona un dispostivo para disparar las notificaciones",
      "MICROAPPS_NO_CAMERA": "Ninguna cámara configurada",
      "MICROAPPS_SETUP_INTRO": "Selecciona dispositivos para configurar tu Micro App",
      "NAME_REQUIRED": "El nombre es requerido",
      "NEED_MORE_TIME": "¿Necesitas más tiempo para agregar dispositivos?",
      "NEST_ADD_DEVICE_ERROR": "Hubo un problema agregando uno o más dispositivos Nest, por favor intenta nuevamente",
      "NEST_CONNECT_TITLE": "Conectarse a Nest",
      "NEST_CONNECT_DESCRIPTION": "Para agregar e interactuar con dispositivos Nest, por favor conéctate a tu cuenta de Nest",
      "NEST_CONNECT_ERROR": "Hubo un error conectándose a tu cuenta de Nest, por favor intenta nuevamente",
      "NEST_GET_DEVICES_ERROR": "Hubo un problema obteniendo tus dispositivos Nest",
      "NEST_NO_DEVICES": "No se encontraron dispositivos Nest en tu cuenta",
      "NO_ABLE_ADD_DEVICE": "No hemos podido agregar el dispositivo. Por favor asegúrate de que las credenciales que ingresaste fueron correctas. Entonces presiona el boón Reintentar.",
      "NO_ADDED_CONTROLLERS": "No has agregado ningún controlador",
      "NO_ADDED_RESPONDERS": "No has agregado ninguna respuesta",
      "NO_AREAS_CREATED": "No se han creado áreas aún",
      "NO_AREAS_EXPLANATION_TEXT": "Las áreas son una manera de organizar los dispositivos para tener un rápido acceso a ellos. Por ejemplo, crea una área llamada \"Sala de estar\" para todos los dispositivos ubicados en tu sala.",
      "NO_AVAILABLE_LOCATIONS": "No hay ubicaciones disponibles para realizar esta acción",
      "NO_CONTROLLERS_EXPLANATION_TEXT": " Usa el botón (+) para agregar uno o más dispositivos que activarán la escena. Por ejemplo: Con un teclado podrás seleccionar un botón específico",
      "NO_DEVICES_EXPLANATION_TEXT": "Los dispositivos son todas las cosas a tu alrededor (sensores, luces, interruptores) que puedes conectar, controlar y agendar!",
      "NO_PRICES_YET": "Todavía no hay Precios.",
      "NO_RECENT_EVENTS_TEXT": "No hay eventos recientes",
      "NO_RESULTS": "No hay resultados para esta búsqueda",
      "NO_RULES_EXPLANATION_TEXT": "Usando Reglas de automatización puedes agendar y automatizar tus dispositivos. Por ejemplo \"Encender las Luces al Atardecer.\"",
      "NO_RULES_YET": "Todavía no hay reglas.",
      "NO_SCENES_EXPLANATION_TEXT": "Usa el botón (+) para agregar y configurar uno o más dispositivos en una escena. Estas \"respuestas\" irán simultáneamente a un comportamiento preestablecido cuando la escena esté activada.",
      "NO_SCENES_TEXT": " Usar escenas te permite controlar diferentes dispositivos con solo tocar un botón!",
      "NO_SCENES_YET": "Todavía no hay escenas",
      "NO_MICROAPPS_DEVICES_SUPPORTED_YET": "No hay dispositivos soportados por este slot",
      "NO_MICROAPPS_TRIGGER_DEVICES_YET": "No hay dispositivos en esta Micro App para que disparen las notificaciones",
      "NO_MICROAPPS_EXPLANATION_TEXT": "Usando Micro Apps, puedes agrupar dispositivos para usarlos en situaciones del día  a día. Por ejemplo, una Micro App 'Doorbell' te permite agrupar una cámara, sensores de movimiento, cerraduras, luces y timbres para controlar acceso en un entrada.",
      "NO_MICROAPPS_YET": "Todavía no hay Micro Apps.",
      "NO_THIRD_PARTY_ACCOUNTS": "No tienes cuentas de terceros vinculadas",
      "NO_TIERS_YET": "Todavía no hay Niveles.",
      "NOT_SEE_NETWORK": "Si no ves tu red, entonces asegúrate de conectarte a",
      "NOT_UNDONE": "Esto no se puede deshacer",
      "OFFLINE_CONNECTION": "Se ha perdido la conexión con el servidor. Por favor verifica tu conexión a internet.",
      "OFFLINE_CONNECTION_RECONNECT": "Se ha perdido la conexión con el servidor. Tratando de reconectar...",
      "OPEN_ETHERNET_PORT": "a un puerto abierto de ethernet.",
      "PASSWORD_POLICY_START" : "La contraseña debe contener al menos:",
      "PASSWORD_POLICY" : "8 caracteres, una letra en mayúscula, una letra en minúscula, un número y un símbolo",
      "PLEASE_CHECK_CONNECTION": "Por favor verifica tu conexión a Internet",
      "PLEASE_CONNECT_SAME_NETWORK": "Por favor ve a tu configuración de WiFi y conéctate a la red Wifi: \"{{wifi_network}}\". Después regresa para terminar de agregar tu dispositivo.",
      "PLEASE_FOLLOW_DIRECTIONS": "Por favor sigue las instrucciones en el",
      "PLEASE_GO_WIFI_SETTINGS": "Por favor ve a tu configuración de WiFi y conecta el IoT Hotspot de Smartenit",
      "PLEASE_SELECT": "Por favor selecciona ",
      "PLEASE_SELECT_ACTION": "Por favor selecciona una acción",
      "PLEASE_SELECT_CONTROL": "Por favor selecciona el control",
      "PLEASE_SELECT_DELAY": "Por favor selecciona el retraso (Opcional)",
      "PLEASE_SELECT_DEVICE": "Por favor selecciona un dispositivo",
      "PLEASE_SELECT_DEVICE_PAIRINGS": "Por favor selecciona un dispositivo para controlar",
      "PLEASE_SELECT_END_DATE": "Por favor selecciona la fecha final: ",
      "PLEASE_SELECT_END_TIME": "Estupendo! Ahora selecciona la hora final:",
      "PLEASE_SELECT_INTERVAL": "Estupendo! Ahora selecciona el intervalo: ",
      "PLEASE_SELECT_OFFSET": "Ahora por favor selecciona la compensación:",
      "PLEASE_SELECT_RESOURCE": "Por favor selecciona un recurso",
      "PLEASE_SELECT_STARTING_DATE": "Ahora por favor selecciona la fecha de inicio:",
      "PLEASE_SELECT_STARTING_TIME": "Ahora por favor selecciona la hora de inicio:",
      "PLEASE_SELECT_TYPE_CONDITION": "Por favor selecciona el tipo de condición",
      "PLEASE_TRY_AGAIN": "por favor inténtalo de nuevo",
      "PRESS_TO_ADD_ACTION": "Agrega una acción presionando el botón (+) ubicado en la esquina superior derecha",
      "PRESS_TO_ADD_CONDITION": "Agrega una condición presionando el botón (+) ubicado en la esquina superior derecha",
      "PRESS_TO_CONTROL_DEVICES": "Presiona el botón + para controlar otros dispositivos con este botón",
      "PRICE_DELETE_CONFIRMATION": "¿Deseas eliminar este precio?",
      "PROMOTIONAL_CONTENT_CONSENT": "Quiero recibir contenido promocional y ofertas de Smartenit",
      "PULL_TO_REFRESH": "Tira para cargar nuevos eventos",
      "RANDOM_TIME_SELECTED": "Tiempo aleatorio seleccionado",
      "RECOVER_PASSWORD_INSTUCTIONS": "Por favor ingresa tu email. Te enviaremos las instrucciones a tu correo para restaurar tu contraseña.",
      "REMOVE_DEVICES": "Eliminar dispositivos",
      "RETRYING_IN": "Reintentando en",
      "REVERSE_INPUT_POLARITY": "Invertir la Polaridad de la Entrada",
      "SCENE_CREATE_ERROR": "Necesitas un dispositivo con la capacidad para controlar escenas",
      "SCHEDULE_YOUR_PROGRAM": "Fija el Horario de tu Programa",
      "SELECT_ACTIVE_DAYS": "Selecciona los días activos",
      "SELECT_DEVICE": "Selecciona un dispositivo",
      "SELECT_HONEYWELL_DEVICES": "Selecciona los dispositivos de Honeywell que deseas agregar:",
      "SELECT_NEST_DEVICES": "Selecciona los dispositivos de Nest que deseas agregar:",
      "SELECT_SOUND_TYPE": "Selecciona el tipo de sonido: ",
      "SELECT_TO_CONNECT": "Selecciona los dispositivos que quieres conectar",
      "SELECT_WIFI_NETWORK": "Selecciona tu red WiFi:",
      "SET_LOCATION_GUIDE_ADD_DEVICES": "Ahora configura tu ubicación. A continuación, se te guiará para agregar nuevos dispositivos",
      "SIGN_UP_SUCCESS": "Tu cuenta ha sido creada exitosamente, por favor verifica tu correo para el enlace de confirmación",
      "SKIP_THIS_STEP": "Omitir este paso >",
      "SLOT_DELETE_CONFIRMATION": "¿Deseas eliminar este slot?",
      "SUMMARY_OF_ACTION": "El resumen de la acción aparecerá aquí a medida que sea configurada",
      "SUMMARY_OF_CONDITION": "El resumen de la condición aparecerá aquí a medida que sea configurada",
      "SUMMARY_OF_CONTROLLER": "El resumen del controlador aparecerá aquí a medida que sea configurado",
      "SUMMARY_OF_RESPONDER": "El resumen de la respuesta aparecerá aquí a medida que sea configurada",
      "SUMMARY_PAIRING": "El resumen del emparejamiento aparecerá aquí a medida que sea configurado",
      "SUNRISE_SELECTED": "Amanecer seleccionado.",
      "SUNSET_SELECTED": "Atarceder seleccionado.",
      "TAP_CHANGE_PICTURE": "Toca para cambiar la imagen",
      "THEN_CLICK_ADD": "Después haz clic en el botón ubicado debajo \"Agregar ahora\"",
      "THERE_WAS_PROBLEM": "Ocurrió un problema al guardar el (la)",
      "THIS_MAY_TAKE_A_FEW_SECONDS": "Esto puede tardar unos pocos segundos",
      "TIER_DELETE_CONFIRMATION": "¿Deseas eliminar este nivel?",
      "TO_YOUR_NETWORK": "a tu red",
      "UPDATED_SUCCESSFULLY": "Actualizado éxitosamente!",
      "USE_CAMERA": "Usar la Cámara",
      "VALIDATION_LENGTH_PASS": "debe de tener por lo menos 8 caracteres",
      "VALIDATION_LOWER_PASS": "debe de tener un caracter en minúscula",
      "VALIDATION_NUMBER_PASS": "debe de tener un número",
      "VALIDATION_SYMBOL_PASS": "tiene un símbolo inválido, por favor verifica e inténtalo de nuevo",
      "VALIDATION_UPPER_PASS": "debe de tener un caracter en mayúscula",
      "WHICH_DAYS_OF_SELECTED": "¿Cuáles días en los días seleccionados?",
      "WHICH_DAYS_OF_WEEK": "¿Cuáles días de la semana?",
      "WIFI_PROV_FIND_DEVICE": "Registrando tu {{device_name}}. Esto puede tardar un minuto...",
      "WINDOW_TIME_SELECTED": "Ventana de tiempo seleccionada.",
      "X_TEN_TAKE_NOTE": "Toma nota de los códigos de hogar y códigos unitarios de tu(s) dispositivo(s) X10.",
      "YES_STILL_ADDING": "Sí, aún estoy agregando",
      "ZIGBEE_FACTORY_RESET": "Restablece los valores de fábrica del ",
      "ZIGBEE_FOLLOW_INSTRUCTIONS": "Siga las instrucciones en el manual del producto.",
      "ZIP_CODE_REQUIRED": "El código postal es requerido",
      "ZONE_TIMERS_UPDATE": "Aquí puedes actualizar los temporizadores de las zonas para"
    },
    "SYMBOL": {
      "AMPERSAND": " & ",
      "COMA": ", "
    },
    "WIZARD": {
      "CENTRALITE_HA_THERMOSTAT": "El termostato Centralite HA usa Zigbee para conectarse con el Gateway de Smartenit.",
      "CENTRALITE_PEARL_THERMOSTAT": "El termostato Centralite Pearl, de control táctil, usa Zigbee para conectarse con el Gateway de Smartenit",
      "RADIO_THERMOSTAT_ZIG": "Después de integrarlo con Smartenit, puedes controlar fácilmente la temperatura a tu comodidad.\n\nTermostatos Soportados: ZigBee CT-32 y CT-80",
      "GATEWAY_HARMONY_G2": "Pequeño pero potente e inteligente Gateway para el hogar que te permite controlar y monitorear varios dispositivos inteligentes.",
      "GATEWAY_HARMONY_P2": "Monitorea y controla cualquier cosa, desde cualquier lugar con el Harmony P2.",
      "GATEWAY_HARMONY_G1": "Monitorea y controla cualquier cosa, desde cualquier lugar y, opcionalmente, enciende cualquier monitor de PC, proyector o TV en un centro de medios inteligentes.",
      "THERMOSTAT_3M_50_WIFI": "Después de integrarlo con Smartenit, puedes controlar fácilmente la temperatura a tu comodidad.\n\nTermostatos Soportados: Wi-Fi CT-50 y CT-80",
      "SWITCHES_OUTLET_ZBMPLUG15": "Este adaptador de enchufe inteligente rastrea los datos de consumo de energía al mismo tiempo que permite el control remoto de encendido / apagado para una gestión completa de la energía.",
      "INPUT_OUTPUT_CONT_EZIO8SA": "Puede activar pequeños dispositivos, alarmas y eventos utilizando señales entrantes de sensores mediante la configuración de un EZIO8SA centralizado.",
      "INPUT_OUTPUT_CONT_EZIO2X4": "Monitorea y controla pequeños dispositivos, alarmas y eventos utilizando señales entrantes de sensores mediante la configuración de un EZIO2x4 centralizado.",
      "INPUT_OUTPUT_CONT_EZIO40": "Controle hasta 4 dispositivos pequeños desde cualquier lugar con este dispositivo de entrada / salida.",
      "SWITCHES_OUTLET_ZBLC15": "Monitorea y controla dos dispositivos tales como luces de techo, ventiladores de techo y pequeños electrodomésticos conectados a tomas de corriente o controlados por interruptores de pared, con un controlador que puede ocultarse en cualquier lugar.",
      "SWITCHES_OUTLET_IOT4R": "Controle hasta 4 dispositivos pequeños desde cualquier lugar con este dispositivo de entrada / salida.",
      "SWITCHES_OUTLET_ZBMLC30": "Amplíe la administración de energía, y monitoree y controle remotamente hasta dos de sus aparatos que consumen mayor energía con un ZBMLC30.",
      "SWITCHES_OUTLET_ZBMLC15": "Monitorea y y controla aparatos, luces de techo, ventiladores de techo y más, todo detrás de un interruptor o tomacorriente, o en cualquier lugar.",
      "KEYPAD_BUTTONS_ZBWS3B": "Este interruptor de 3 botones inalámbrico, operado por batería, puede conectarse a varios dispositivos ZigBee. Un solo botón puede controlar varios dispositivos para crear escenas.",
      "OTHER_ZBVC_1": "Este controlador inalámbrico se instala fácilmente en las válvulas circulares existentes para darte un control preciso sobre tus líneas de agua o gas.",
      "SENSOR_ZBHT_2": "Haz que tu y tu sistema de control sean conscientes de la temperatura y la humedad en cualquier lugar con la adición de este sensor de batería con una pantalla incorporada.",
      "SENSOR_ZBMS3_1": "Este sensor proporciona información sobre el movimiento, la temperatura y la luz ambiente que puede utilizarse para influir en otros dispositivos.",
      "SENSOR_ZBWDS": "Utiliza este sensor inalámbrico ZigBee HA (Home Automation Profile) para monitorear puertas, gabinetes y ventanas.",
      "IRRIGATION_RAINBEE_8": "Maximiza la eficiencia de agua y energía utilizando tu sistema de riego sólo cuando lo desees y lo necesites. RainBee8 te permite monitorear y controlar de manera flexible hasta 8 zonas de rociadores de forma independiente.",
      "KEYPAD_BUTTONS_ZBALRMB": "Utiliza el timbre de la puerta ZBALRMB y el interruptor inalámbrico para incluir tu entrada en tu red de automatización del hogar.",
      "LIGHTS_GE_LINK_BULB": "Controla la atenuación, enciende y apaga la bombilla GE Link de forma remota.",
      "LIGHTS_CREE_CONNECTED_LED": "Controla el oscurecimiento de las luces incandescentes y halógenas con un LED Cree Connected.",
      "LIGHTS_IKEA_TRADFRI_TUNABLE_WHITE": "Conéctala a Smartenit para controlar y monitorear fácilmente tu luz. Te permite aclarar/atenuar y encender/apagar de forma remota. Puedes ajustar la liz a diferentes temperaturas como blanco cálido y blanco suave. Agrégalo a las Reglas de Automatización para automatizar la iluminación.",
      "LIGHTS_OSRAM_RGBW": "Ajusta tus luces a miles de colores diferentes. Luz de alta calidad que puedes configurar, atenuar, y controlar desde la App. Los products que lo soportan son: \n1. A19 Full Color + Tunable White LED Bulb\n2. BR30 Full Color + Tunable White LED Bulb\n3. Recessed Light Full Color + Tunable White\n4. Flex Light Strip\n5. Landscape Lights, Gardenspots Full Color + Tunable White",
      "LIGHTS_OSRAM_WHITE": "Luz blanca LED ajustable que te permite cambiarla a diferentes tonos de luz blanca. Luz de alta calidad que puedes configurar, atenuar, y controlar desde la App. Los products que lo soportan son: \n1. A19 Tunable White LED Bulb\n2. BR30 Tunable White LED Bulb\n3. Recessed Light Tunable White",
      "LIGHTS_OSRAM_DIMMABLE": "Luz de alta calidad que puedes configurar, atenuar, y controlar desde la App. Los products que lo soportan son: \n1. A19 Tunable White LED Bulb\n2. BR30 Tunable White LED Bulb\n3. PAR38 Tunable White LED Bulb",
      "DOORLOCK_SMARTCODE_DEADBOLT": "Smartcode Deadbolt es una cerradura de puerta inalámbrica con entrada codificada.",
      "DOORLOCK_CONTEMPORARY_SMARTCODE_DEADBOLT": "Contemporary Smartcode Deadbolt es una cerradura de puerta inalámbrica con entrada codificada.",
      "DOOR_LOCK_SMARTCODE_LEVER": "Smartcode Lever With Home Connect es una cerradura de puerta inalámbrica con entrada codificada.",
      "DOORLOCK": "Monitorea y controla de manera remota tu cerradura conectándola a un gateway de Smartenit. Interactúa con tu cerradura utilizando nuestras poderosas reglas de automatización",
      "OTHER_ZBALRM": "Utiliza la versátil sirena ZBALRM para avisarte cuando algo suceda en tu red de automatización domestica.",
      "SENSOR_ZBLIQS": "Utiliza ZBLIQS para evitar daños por fugas de tuberías, desbordamiento de ollas de presión, fugas de calentadores de agua y mucho más.",
      "OTHER_ZBPCM": "Obten toda la información de energía de tu casa directamente desde tu medidor eléctrico para configurar estrategias y programas de ahorro de energía.",
      "SENSOR_ZBMS3": "Este sensor proporciona información sobre el movimiento, la temperatura y la luz ambiente que puede utilizarse para influir en otros dispositivos.",
      "IRRIGATION_RAINBEE_16": "Maximiza la eficiencia de agua y energía utilizando tu sistema de riego sólo cuando lo desees y lo necesites. RainBee16 te permite monitorear y controlar de forma flexible hasta 16 zonas de rociadores de forma independiente",
      "IRRIGATION_EZFLORA": "Puedes monitorizar y controlar tu sistema de riego desde cualquier lugar con el controlador de riego EZFlora",
      "INSTEON_EZSNSRF": "Traduce señales RF simples en comandos sofisticados de domótica con EZSnsRF",
      "INSTEON_EZUIRT": "Puedes conectar tu sistema A/V u otros dispositivos IR a tu sistema de control de hogar y consolidar tus controles remotos usando EZUIRT",
      "SWITCHES_OUTLET_ENERGY_SMART": "Enchufe de Zigbee para la pared que te permite controlar y monitorear un dispositivo conectado (max 15A). También puedes controlar el uso de energía a lo largo del tiempo con un chip de medición incorporado. La salida inferior es controlable y la salida superior siempre está encendida.",
      "SWITCHES_OUTLET_INSTEON_DIMMER": "Controla una luz remotamente, enciéndela y apágala y ajusta los niveles de brillo. Conéctalo a Smartenit y controla tus dispositivos remotamente. Automatiza fácilmente usándolo en las \"Reglas de automatización\".",
      "SWITCHES_OUTLET_INSTEON_PLUGIN": "Controla las lámparas y los aparatos enchufados sin necesidad de cables. Conéctalo a Smartenit y controla tus dispositivos remotamente. Automatiza fácilmente usándolo en las \"Reglas de automatización\".",
      "SWITCHES_OUTLET_INSTEON_OUTLET_RECEP": "Controlador de escenas de instalación en pared mas interruptor que te permite controlar fácilmente tus electrodomesticos. Conéctalo a Smartenit y controla tus dispositivos remotamente. Automatiza fácilmente usándolo en las \"Reglas de automatización\".",
      "SWITCHES_OUTLET_X10_DIMMER": "Enciende, Apaga y Ajusta de forma remota el brillo de los dispositivos conectados",
      "SWITCHES_OUTLET_X10_RELAY": "Activa/Desactiva remotamente los dispositivos conectados con un Módulo X10 Appliance",
      "DOORLOCK_YALE_REAL_LIVING": "El Yale Real Living Lock es una cerradura sin llave habilitada para ZigBee",
      "CAMERAS_FOSCAM_FI9821P": "Cámara de Seguridad IP WiFi con panorámica HD 720P, Inclinacón, Zoom, Audio bidireccional, Visión nocturna de hasta 26 pies, y más",
      "SELECT_AN_OPTION": "Selecciona una opción",
      "INFO_ADD_GATEWAY_START": "Tu",
      "INFO_ADD_GATEWAY_METHOD": "puede conectarse a través de Ethernet y WiFi. Por favor seleccione la opción que desea usar:",
      "USE_WIFI": "WiFi",
      "USE_ETH": "Ethernet",
      "NEST_PROTECT": "Conecta e integra el Nest Protect con la App de Smartenit para programar acciones inteligentes. Mejora el rendimiento con Reglas de Automatización e interactividad con todos tus otros dispositivos.",
      "NEST_THERMOSTAT": "Conecta e integra el Nest Thermostat con la App de Smartenit para programar acciones inteligentes. Mejora el rendimiento con Reglas de Automatización e interactividad con todos tus otros dispositivos.\n\nTermostatos Soportados: Nest Learning Thermostat, Nest Thermostat E",
      "HONEYWELL_THERMOSTAT": "Conecta e integra los termostatos de Honeywell con la aplicación de Smartenit para una inteligencia procesable. Mejora el rendimiento con las reglas de automatización y la interactividad con todos tus otros dispositivos.",
      "GOOGLE_HOME": "Intregra Google Home con Smartenit para control de voz. Mejora el rendimiento con una fácil interactividad con todos tus otros dispositivos.",
      "AMAZON_ALEXA": "Intregra Amazon Alexa con Smartenitpara control de voz. Mejora el rendimiento con una fácil interactividad con todos tus otros dispositivos.",
      "ZEN_THERMOSTAT": "Zen es un termostato para el hogar que luce hermoso en tu pared. Después de integrarlo con Smartenit, puedes controlar fácilmente la temperatura a tu comodidad. Disponible en negro o blanco, Zen se integra perfectamente en tu diseño interior actual. Se conecta al Gateway de Smartenit usando Zigbee.",
      "NYCE_MOTION_SENSOR": "Detecta movimiento fácilmente y toma acción al usarlo con nuestras poderosas Reglas de Automatización para alertarte o desencadenar eventos.\nSoportado: NYCE Ceiling Motion Sensor y Curtain Motion Sensor",
      "NYCE_DOOR_WINDOW_SENSOR": "Detecta fácilmente si las puertas y ventanas estan Abiertas o Cerradas. Toma acción al usarlo con nuestras poderosas Reglas de Automatización para alertarte o desencadenar eventos.",
      "EVSE": "Monitorea, controla, y personaliza tus horarios de carga de EV.",
      "IOT8": "Compacto, pero poderoso, controlador inteligente con 8 salidas para pequeñas a medianas cargas (irrigación, acceso de entrada, control de zona HVAC, etc.) y 6 entradas para monitorear una variedad de sensores (movimiento, temperatura, humedad, líquido, etc.)"
    },
    "CATEGORIES": {
      "ALL": "Todos",
      "GATEWAYS_HUBS": "Gateways/Hubs",
      "CAMERAS": "Cámaras",
      "LIGHTS": "Luces",
      "THERMOSTATS": "Termostatos",
      "INPUT_OUTPUT": "Entrada/Salida",
      "DOOR_LOCKS": "Cerraduras de Puertas",
      "SENSORS": "Sensores",
      "SWITCHES_OUTLETS": "Interruptores/Tomacorrientes",
      "IRRIGATION": "Irrigación",
      "KEYPAD_BUTTONS": "Teclados/Botones",
      "VOICE_CONTROL": "Control por voz",
      "OTHER": "Otros"
    },
    "STEPS": {
      "DEFAULT": "Por favor sigue las instrucciones del manual del producto para restablecer los valores de fábrica. Luego haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_THERMOSTAT_3M_50_WIFI": "Siga el manual del producto para conectar el termostato a Wi-Fi.",
      "2_THERMOSTAT_3M_50_WIFI": "Anote la dirección IP asignada al termostato. Si no es el reenvío de puertos, entonces use el puerto 80 en el formulario más adelante.",
      "3_THERMOSTAT_3M_50_WIFI": "Una vez que hayas seguido las instrucciones anteriores, haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_SWITCHES_OUTLET_IOT4R": "Conecta el IoT4R en una toma de corriente. Después haz clic en el botón ubicado debajo \"Agregar ahora\"",
      "1_CAMERAS_FOSCAM_FI9821P": "Sigue las instrucciones de la guía de inicio rápido ubicada en la lista de arriba para conectar tu cámara a Internet",
      "2_CAMERAS_FOSCAM_FI9821P": "Graba la dirección IP y el puerto de la cámara Foscam",
      "1_NEST": "Después de completar la instalación del producto con la App de Nest, haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_HONEYWELL": "Después de completar la instalación del producto con la App de Honeywell Lyric, haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_GOOGLE_HOME": "Ve a la sección Actions en la app de Google Home y selecciona Smartenit. Ingresa con tu usuario y clave de Smartenit. Ahora, Google Home puede acceder a todos los dispositivos conectados a tu gateway de Smartenit.",
      "1_AMAZON_ALEXA": "Ve a la sección Skills en la app de Amazon Alexa y selecciona Smartenit. Ingresa con tu usuario y clave de Smartenit. Ahora, Amazon Alexa puede acceder a todos los dispositivos conectados a tu gateway de Smartenit.",
      "1_OSRAM": "Restaura de fábrica el producto de esta forma:\nPréndelo, espera 3 segundos, y apágalo. Haz esto 5 veces en secuencia. La luz parpaderá 3 veces para confirmar el reseteo. Ahora puede agregarse al Gateway de Smartenit. Después haz clic en el botón ubicado debajo \"Agregar ahora\".",
      "1_SMART_OUTLET": "Presiona el botón de programa durante 15 segundos, hasta que el LED de estado parpadee tres veces (el LED parpadeará una vez a los 3 segundos, 10 segundos y 15 segundos), y luego suéltalo.",
      "2_SMART_OUTLET": "Presiona el botón de control local una vez dentro de 2 segundos. El LED de estado parpadeará rápidamente durante unos segundos y luego se apagará.",
      "3_SMART_OUTLET": "Una vez que hayas seguido las instrucciones anteriores, haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_THERMOSTAT": "Por favor sigue las instrucciones del manual del producto para restablecer los valores de fábrica. Luego haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_DOORLOCK_SMARTCODE_LEVER": "Abre la placa en la parte posterior para acceder a los botones de emparejamiento.",
      "2_DOORLOCK_SMARTCODE_LEVER": "Presiona el botón derecho 9 veces.",
      "3_DOORLOCK_SMARTCODE_LEVER": "Presiona el botón izquierdo 4 veces.",
      "4_DOORLOCK_SMARTCODE_LEVER": "Haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_DOORLOCK_YALE_REAL_LIVING": "Coloca la palma de tu mano sobre la pantalla táctil y aparecerá un panel numérico.",
      "2_DOORLOCK_YALE_REAL_LIVING": "Ingresa tu código maestro y a continuación presiona # (Ejemplo: 1234 y después #).",
      "3_DOORLOCK_YALE_REAL_LIVING": "Presiona 7 para el modo de configuración inalámbrica.",
      "4_DOORLOCK_YALE_REAL_LIVING": "Presiona 1 y a continuación #.",
      "5_DOORLOCK_YALE_REAL_LIVING": "Haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_INSTEON_LED_BULB": "Para vincular manualmente, desatornille la bombilla LED por un momento y vuelva a insertarla en el zócalo. Luego haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_IKEA_TRADFRI_TUNABLE_WHITE": "Restaura de fábrica el producto de esta forma:\nDescansando la luz, el ciclo de potencia se repite rápidamente 6 veces. Después haz clic en el botón ubicado debajo \"Agregar ahora\".",
      "1_EVSE": "Rápidamente presiona el Botón Push 13 veces para restaurarlo de fábrica (el LED azul parpadeará rápidamente cuando esté listo para unirse).",
      "2_EVSE": "Haz click en el botón ubicado debajo \"Agregar ahora\".",
      "1_IOT8": "Rápidamente presiona el Botón Push 13 veces para restaurarlo de fábrica (el LED rojo parpadeará rápidamente cuando esté listo para unirse).",
      "2_IOT8": "Haz click en el botón ubicado debajo \"Agregar ahora\"."
    },
    "WELCOME": {
      "1_TITLE": "Controla tus dispositivos",
      "1_DESCRIPTION": "Formas fáciles e intuitivas de controlar/monitorear tus dispositivos. Atenua las luces, inicia el sistema de irrigación, bloquea la puerta, apaga el calentador de agua.",
      "2_TITLE": "Ecosistema de dispositivos",
      "2_DESCRIPTION": "Amplia gama de dispositivos para ayudarte a controlar/monitorear tus luces, electrodomésticos, irrigación !y más!",
      "3_TITLE": "Reglas de Automatización",
      "3_DESCRIPTION": "Se creativo y haz tus propias reglas. Crea reglas personalizadas inteligentes para automatizar tu hogar. Encender las luces al atardecer. Apagar los electrodomésticos cuando no se necesitan para ahorrar energía, la irrigación funciona según tu horario."
    },
    "RESOURCES": {
      "QUICK_GUIDE": "Guía de Inicio Rápido",
      "BUY": "Comprar",
      "USER_GUIDE": "Guía del Usuario",
      "INSTALATION_GUIDE": "Guía de Instalación",
      "GATEWAY_INSTRUCTIONS": "<ul><li>Conecta el cable de Ethernet a tu Gateway.</li><li>Asegúrate de que tu dispositivo móvil y el Gateway está en la misma red.</li><li>Haz click en Continuar y espera alrededor de 30 seg.</li><li>Cuando el Gateway sea descubierto, \"1 dispositivo encontrado\" será mostrado en pantalla</li></ul>"
    },
    "GENERAL": {
      "AFTER": "después del",
      "AND": "y",
      "AT": "a",
      "BEFORE": "antes del",
      "BETWEEN": "entre",
      "COLOR": "color",
      "DEVICE": "el dispositivo",
      "DURING": "durante",
      "EACH": "cada",
      "EVERY": "cada",
      "FOR": "para",
      "IN": "en",
      "ON": "en",
      "OR": "O",
      "THE_1": "la",
      "THE_2": "el",
      "TO": "en",
      "WHEN": "cuando"
    },
    "COLORS": {
      "BLACK": "negro",
      "BLUE": "azul",
      "GREEN": "verde",
      "CYAN": "cyan",
      "VIOLET": "violeta",
      "PURPLE": "púrpura",
      "GRAY": "gris",
      "BROWN": "marrón",
      "SILVER": "plateado",
      "RED": "rojo",
      "ROSE": "rosa",
      "FUCHSIA": "fucsia",
      "ORANGE": "naranja",
      "GOLD": "oro",
      "YELLOW": "amarillo",
      "WHITE": "blanco",
      "WARMWHITE": "blanco cálido",
      "SOFTWHITE": "blanco suave",
      "DAYLIGHTWHITE": "luz del día",
      "COOLWHITE": "blanco frío"
    },
    "ORDINALS": {
      "FIRST": "º",
      "SECOND": "º",
      "THIRD": "º",
      "N": "º"
    },
    "AR": {
      "CONDITIONS": {
        "BATTERY": "Batería",
        "CLOSE_OPEN": "Cerrar/Abrir",
        "CONSUMPTION": "Consumo",
        "COOLING_SETPOINT": "Enfriamiento",
        "COST": "Costo",
        "ENERGY": "Energía (kWh)",
        "HEATING_SETPOINT": "Calentamiento",
        "HUMIDITY": "Humedad",
        "LEAK_DETECTION": "Detección de Fugas",
        "LEVEL": "Nivel",
        "LOAD": "Carga",
        "LOAD_1": "Carga 1",
        "LOAD_2": "Carga 2",
        "LOCK": "Bloqueo",
        "MOTION": "Movimiento",
        "POWER": "Potencia (kW)",
        "SESSION": "Sesión",
        "SWITCH": "Interruptor",
        "SWITCHES": "Interruptores",
        "TEMPERATURE": "Temperatura",
        "THERMOSTAT_MODE": "Modo",
        "WARNING": "Advertencia",
        "BUTTON": "Botón",
        "SMOKE": "Humo",
        "STATUS": "Estado",
        "CARBONMONO": "CO"
      },
      "CONDITIONS_NL": {
        "ALARMED": "Alarmado",
        "AUTO": "Auto",
        "BATTERY": "la Batería de",
        "BUTTON": "El botón",
        "CHARGE_LEVEL": "el Nivel de carga de",
        "CHARGER_STATUS": "el Estado de carga de",
        "CHARGING_SESSION": "la Sesión de carga de",
        "COOL": "Frío",
        "COOLING_SETPOINT": "el punto de ajuste de enfriamiento de",
        "CURRENT": "la Corriente de",
        "EMERGENCY_BUTTON": "El botón de emergencia",
        "ENERGY": "la Energía de",
        "ENERGY_CONSUMPTION": "el Consumo de energía de",
        "FAN": "el ventilador de",
        "FREQUENCY": "la Frecuencia de",
        "HEAT": "Calor",
        "HEAT_COOL": "Calor-Frío",
        "HEATING_SETPOINT": "el punto de ajuste de calentamiento de",
        "HIGH": "Alto",
        "HUMIDITY": "la Humedad de",
        "IDLE": "Ocioso",
        "IS_ALARMED": "esté Alarmado",
        "IS_CLOSED": "esté Cerrado",
        "IS_OCCUPIED": "esté Ocupado",
        "IS_OFF": "esté Apagado",
        "IS_ON": "esté Prendido",
        "IS_OPEN": "esté Abierto",
        "IS_LOCKED": "esté Bloqueado",
        "IS_NOT_ALARMED": "no esté Alarmado",
        "IS_UNOCCUPIED": "esté Desocupado",
        "IS_UNLOCKED": "esté Desbloqueado",
        "LOW": "Bajo",
        "MEDIUM": "Medio",
        "MODE": "el modo de",
        "OFF": "Apagado",
        "ON": "Prendido",
        "NOT_ALARMED": "No Alarmado",
        "POWER": "la Potencia de",
        "PRESSURE": "la Presión de",
        "PRESSED": "Presionado",
        "SMART": "Smart",
        "STATE": "el estado de",
        "SWITCH_1": "Interruptor 1",
        "SWITCH_2": "Interruptor 2",
        "SWITCH_3": "Interruptor 3",
        "TEMPERATURE": "la Temperatura de",
        "USAGE": "el uso de",
        "VOLTAGE": "el Voltaje de",
        "WARNING_MODE": {
          "BURGLAR": "Robo",
          "FIRE": "Fuego",
          "PANIC": "Pánico",
          "BELL": "Campana"
        }
      },
      "CONNECTORS": {
        "DETECTS": "detecta",
        "EXCEEDS": "supera",
        "IS": "es",
        "IS_ABOVE": "esté por encima de",
        "IS_BELOW": "esté por debajo de",
        "IS_DIFFERENT_FROM": "es diferente de",
        "IS_EQUAL_TO": "es igual a",
        "IS_GREATER_OR_EQUAL_TO": "es mayor o igual a",
        "IS_LOWER_OR_EQUAL_TO": "es menor o igual a",
        "IS_PRESSED": "esté presionado",
        "IS_PRESSED_ON": "esté presionado en",
        "IS_SET_TO": "esté configurado en",
        "IS_UNDER": "esté por debajo de",
        "MATCHES": "coincide con",
        "RANDOMLY": "aleatoriamente",
        "SENDS_ALERT": "envía alerta"
      },
      "EFFECTS": {
        "COLOR": "Color",
        "COOLING_SETPOINT": "Enfriamiento",
        "EMAIL": "Correo",
        "HEATING_SETPOINT": "Calentamiento",
        "LEVEL": "Nivel",
        "LOAD": "Carga",
        "LOAD_1": "Carga 1",
        "LOAD_2": "Carga 2",
        "LOCK": "Bloqueo",
        "NOTIFICATION": "Notificación",
        "PROGRAMS": "Programas",
        "SELECT_ACTION": "Selecciona Acción",
        "SELECT_PROGRAM": "Selecciona Programa",
        "SELECT_ZONE": "Selecciona Zona",
        "SWITCH": "Interruptor",
        "THERMOSTAT_MODE": "Modo",
        "WARNING": "Advertencia",
        "ZONES": "Zonas"
      },
      "EFFECTS_NL": {
        "AFTER": "después de",
        "EXECUTE": "ejecuta",
        "EXECUTE_METHOD": "ejecuta el método",
        "LOCK": "Bloquea",
        "PROGRAM": "Programa",
        "SEND_EMAIL": "Envía un Correo",
        "SEND_PUSH_NOTIFICATION": "Envía una Notificación",
        "SET": "establece",
        "START_THE": "inicia el ",
        "SOUND_ON": "sonido en ",
        "ON_THE": "en la",
        "START_CHARGING_SESSION": "Inicia una sesión de carga",
        "START_CHARGING_SESSION_IN": "Inicia una sesión de carga en",
        "STOP_CHARGING_SESSION_IN": "Detiene una sesión de carga en",
        "START_WARNING": "Empieza a advertir",
        "START_WARNING_ON": "Empieza a advertir en",
        "STOP_WARNING": "Deja de advertir",
        "STOP_WARNING_ON": "Deja de advertir en",
        "TOGGLE": "alterna",
        "TURN_ON": "prende",
        "TURN_OFF": "apaga",
        "UNLOCK": "Desbloquea",
        "ZONE": "Zona"
      },
      "STATES": {
        "CLOSED": "Cerrado",
        "CO": "CO",
        "CO_DETECTED": "CO Detectado",
        "NO_CO": "Sin CO",
        "EMERGENCY": "emergencia",
        "EMERGENCY_DETECTED": "Emergencia Detectada",
        "NO_EMERGENCY": "Sin Emergencia",
        "FIRE": "Fuego",
        "FIRE_DETECTED": "Fuego Detectado",
        "NO_FIRE": "Sin Fuego",
        "GLASS_BREAK": "Rotura de vidrio",
        "GLASS_BREAK_DETECTED": "Rotura de vidrio Detectada",
        "NO_GLASS_BREAK": "Sin Rotura de vidrio",
        "LEAK": "Fuga",
        "LEAK_DETECTED": "Fuga Detectada",
        "NO_LEAK": "Sin Fuga",
        "MOTION": "Movimiento",
        "NO_MOTION": "Sin Movimiento",
        "OPEN": "Abierto",
        "SMOKE": "Humo",
        "NO_SMOKE": "Sin Humo",
        "VIBRATION": "Vibración",
        "VIBRATION_DETECTED": "Vibración Detectada",
        "NO_VIBRATION": "Sin Vibración",
        "WARNING": "advertencia",
        "WATER": "Agua",
        "NO_WATER": "Sin Agua"
      },
      "TIME": {
        "REPEATING_EVERY": "repitiendo cada",
        "STARTING_ON": "empezando desde",
        "TIME_MATCHES": "tiempo coincide"
      }
    },
    "SCENES": {
      "CONTROLLERS": {
        "BUTTON_1": "Botón 1",
        "BUTTON_2": "Botón 2",
        "BUTTON_3": "Botón 3"
      }
    },
    "TIME": {
      "DAYS": {
        "SUN": "Dom",
        "MON": "Lun",
        "TUE": "Mar",
        "WED": "Mie",
        "THU": "Jue",
        "FRI": "Vie",
        "SAT": "Sab"
      },
      "MONTHS": {
        "JANUARY": "Enero",
        "FEBRUARY": "Febrero",
        "MARCH": "Marzo",
        "APRIL": "Abril",
        "MAY": "Mayo",
        "JUNE": "Junio",
        "JULY": "Julio",
        "AUGUST": "Agosto",
        "SEPTEMBER": "Septiembre",
        "OCTOBER": "Octubre",
        "NOVEMBER": "Noviembre",
        "DECEMBER": "Diciembre"
      },
      "FRACTIONS": {
        "DAY": "día",
        "DAYS": "días",
        "HR": "hr",
        "HRS": "hrs",
        "HOUR": "hora",
        "HOURS": "horas",
        "MIN": "min",
        "MINS": "mins",
        "MINUTE": "minuto",
        "MINUTES": "minutos",
        "SEC": "seg",
        "SECS": "segs"
      },
      "PERIODS": {
        "AT": "en el",
        "AT_HOUR": "a las",
        "DAY_OF_THE_MONTH": "día del mes",
        "ON_EVEN_DATES": "en días pares",
        "ON_ODD_DATES": "en días impares",
        "ON_WEEKDAYS": "entre semana",
        "ON_WEEKENDS": "en los fines de semana",
        "EVERY": "cada",
        "EVERY_DAY": "cada día",
        "EVERY_HOUR": "cada hora",
        "HOURLY": "cada hora",
        "SUNRISE": "amanecer",
        "SUNSET": "atardecer",
        "TODAY": "hoy"
      }
    },
    "DEVICES": {
      "EVSE": {
        "FAULTS": {
          "DEFAULT": "Ocurrió un error inesperado con tu dispositivo.",
          "METER_FAILURE": "Un error interno del dispositivo está impidiendo obtener medidas eléctricas.",
          "OVER_VOLTAGE": "El nivel de voltaje de entrada es demasiado alto.",
          "UNDER_VOLTAGE": "El nivel de voltaje de entrada es demasiado bajo.",
          "OVER_CURRENT": "Se detectó una corriente de carga más alta que la soportada por el cargador.",
          "CONTACT_WET_FAILURE": "Se detectó una tensión en los pines de carga incluso con los relays desactivados.",
          "CONTACT_DRY_FAILURE": "Se detectó una ausencia de voltaje después de habilitar los relays.",
          "GROUND_FAULT": "Suministro de corriente desequilibrado.",
          "PILOT_SHORT_CIRCUIT": "Amplitud de la señal piloto cortocircuitada a tierra.",
          "WRONG_POWER_SUPPLY": "No se pudo determinar el nivel de suministro de energía adecuado."
        },
        "STATUS": {
          "CHARGING": "Cargando",
          "CHARGED": "Cargado",
          "FAULT": "Error",
          "NOT_CHARGING": "No Cargando",
          "PLUGGED": "Conectado",
          "READY": "Listo",
          "UNKNOWN": "Desconocido",
          "UNPLUGGED": "Desconectado"
        },
        "LABELS": {
          "AUTO_START": "Modo de auto-inicio",
          "BATTERY_CAPACITY": "Capacidad de la batería",
          "CAR_MODEL": "Modelo del carro",
          "CHARGE_LEVEL": "Nivel de carga",
          "CURRENT": "Corriente",
          "DETAILS": "Detalles",
          "ELECTRIC_RANGE": "Rango eléctrico",
          "ENERGY": "Energía",
          "FULL_CHARGE_AT": "Carga total en",
          "GENERAL": "General",
          "LEFT": "restante",
          "POWER": "Potencia",
          "SESSION": "Sesión",
          "SESSION_COST": "Costo de la sesión",
          "SESSION_TIME": "Tiempo de la sesión",
          "STOP": "Detener",
          "TIME": "Tiempo",
          "VOLTAGE": "Voltaje"
        },
        "TEXTS": {
          "CONFIRM_DELETE_STOP_SCHEDULE": "¿Estás seguro de borrar este programa?",
          "NO_SESSIONS": "No se han encontrado sesiones de carga para este dispositivo.",
          "NO_UPCOMING_SESSIONS": "No tienes sesiones próximas. ¡Ve a reglas de automatización para programar una nueva!",
          "OVERALL_ENERGY_CONSUMPTION": "Consumo total de energía",
          "RECEIVE_NOTIFICATION": "¿Recibir notificación?",
          "SCHEDULE_STOP": "Programar detención",
          "SESSION_HISTORY": "Historial de Sesiones",
          "STOP_CHARGING_WHEN": "Deja de cargar cuando...",
          "STOP_SESSION_NOTI_SUBJECT": "La sesión de carga se detuvo",
          "STOP_SESSION_NOTI_TEXT": "La sesión de carga #{{sessionId}} de tu {{deviceName}} se ha detenido",
          "STOP_SESSION_SCHEDULE_ERROR": "Ha habido un problema al programar la detención de su sesión de carga",
          "UPCOMING_SESSIONS": "Próximas Sesiones"
        },
        "WALKTHROUGHS": {
          "HELP": {
            "STEP_1": {
              "TITLE": "Estación de carga EV",
              "CONTENT": "Te guiaremos a través de las diferentes cosas que puedes hacer con tu estación de carga EV."
            },
            "STEP_2": {
              "CONTENT": "Dentro de esta área, puedes ver el estado actual de tu dispositivo (desenchufado, enchufado, cargando, cargado y falla) e información adicional como el nivel de carga actual."
            },
            "STEP_3": {
              "CONTENT": "Mueve este control deslizante para establecer el nivel de carga inicial de su batería. Con esta información, podemos darte estimaciones del tiempo de carga restante y la disponibilidad de distancia total."
            },
            "STEP_4": {
              "CONTENT": "Con este botón puedes iniciar o detener una nueva sesión de carga."
            },
            "STEP_5": {
              "CONTENT": "Haz click en esta opción para ver más detalles de tu dispositivo."
            },
            "STEP_6": {
              "CONTENT": "Desde aquí, puedes ver más información de tu estación de carga, como:<br/><strong>Sesión: </strong> En esta pestaña, puedes ver tus próximas sesiones en modo conectado, o información más avanzada mientras carga tu dispositivo como el tiempo restante y el costo de la sesión.<br/><strong>Detalles:</strong> Los detalles técnicos de tu dispositivo, como la corriente y el voltaje."
            },
            "STEP_7": {
              "CONTENT": "Para ver más detalles y configuraciones de este dispositivo, puedes hacer click en el botón de detalles. Allí, puedes: <br/><ul><li>Cambiar el nombre y la imagen de tu dispositivo.</li><li> Ver información histórica de tus sesiones de carga.</li><li>Modificar los ajustes del dispositivo tales como límites de corriente y el modelo de tu automóvil.</li></ul><strong>Nota:</strong> Si desea ver estimaciones de tiempo y distancia, debes establecer el modelo de tu automóvil o establecer sus detalles técnicos de forma manual."
            }
          }
        }
      }
    },
    "ERRORS": {
      "DEFAULT_ERROR": "Lo sentimos, parece que algo salió mal, por favor intenta nuevamente. Si los problemas persisten, háganoslo saber y lo analizaremos.",
      "AUTH": {
        "INVALID_EMAIL": "El email es inválido",
        "INVALID_USER_CREDENTIALS": "El email o la contraseña son incorrectos, por favor verifique y vuelva a intentarlo",
        "LOGIN_ATTEMPTS_EXCEEDED": "El número de intentos de autenticación ha sido excedido",
        "PASSWORD_SPECIAL_CHARACTER": "La contraseña debe tener al menos un símbolo",
        "PASSWORD_SPECIAL_CHARACTER_DESC": "Un símbolo",
        "PASSWORD_REQUIRED": "La contraseña es requerida",
        "USER_PASS_REQUIRED": "El usuario y la contraseña son requeridos"
      },
      "SIGN_UP": {
        "ALREADY_REGISTERED": "¡Ya tienes una cuenta!, Haz click en Ingresa para continuar",
        "DEFAULT_ERROR": "Error creando tu cuenta, por favor intenta nuevamente",
        "PASSWORD_LOWERCASE": "La contraseña debe contener al menos una minúscula",
        "PASSWORD_LOWERCASE_DESC": "Una minúscula",
        "PASSWORD_MIN_LENGTH": "La contraseña debe tener al menos 8 caracteres",
        "PASSWORD_MIN_LENGTH_DESC": "8 caracteres",
        "PASSWORD_NOT_MATCH": "Las contraseñas no coinciden",
        "PASSWORD_NUMBER": "La contraseña debe contener al menos un número",
        "PASSWORD_NUMBER_DESC": "Un número",
        "PASSWORD_UPPERCASE": "La contraseña debe contener al menos una mayúscula",
        "PASSWORD_UPPERCASE_DESC": "Una mayúscula"
      },
      "SIGN_IN": {
        "DEFAULT_ERROR": "Error autenticándose",
        "PASSWORD_LOWERCASE": "La contraseña no tiene minúsculas",
        "PASSWORD_MIN_LENGTH": "La contraseña tiene menos de 8 caracteres",
        "PASSWORD_NUMBER": "La contraseña no tiene números",
        "PASSWORD_UPPERCASE": "La contraseña no tiene mayúsculas"
      },
      "FORGOT_PASS": {
        "DEFAULT_ERROR": "Lo sentimos. No existe una cuenta para este email. Por favor verifique por errores e intente nuevamente.",
        "EMAIL_FAILURE": "Lo sentimos, algo salió mal en nuestro servidor. Por favor intenta de nuevo o contacta a soporte si recibes este error nuevamente.",
        "EXTERNAL_ACCOUNT": "Tu has creado una cuenta usando {{provider}}, por favor usa {{provider}} para continuar"
      }
    },
    "WALKTHROUGHS": {
      "AREAS_HELP": {
        "STEP_1": {
          "TITLE": "Areas",
          "CONTENT": "Puedes agrupar dispositivos dentro de una ubicación usando áreas. Aquí puedes agregar, eliminar y asociar dispositivos a ellas."
        },
        "STEP_2": {
          "CONTENT": "Haz click en este botón para agregar nuevas areas."
        },
        "STEP_3": {
          "CONTENT": "Busca tus áreas por sus nombres."
        },
        "STEP_4": {
          "CONTENT": "Haz click en una área para ver sus detalles y modificar sus dispositivos."
        }
      },
      "DASHBOARD_HELP": {
        "STEP_1": {
          "TITLE": "Dashboard",
          "CONTENT": "Este es el dashboard, una de las secciones principales en la aplicación. Te daremos una descripción general de lo que puede hacer desde aquí."
        },
        "STEP_2": {
          "CONTENT": "Agrega nuevos recursos, como dispositivos, áreas, reglas de automatización o escenas."
        },
        "STEP_3": {
          "CONTENT": "Esta es tu ubicación seleccionada actual"
        },
        "STEP_4": {
          "CONTENT": "Puedes controlar y monitorear todos tus dispositivos desde aquí, e incluso filtrarlos por área."
        },
        "STEP_5": {
          "TITLE": "Eventos",
          "CONTENT": "Aquí puedes ver la lista de eventos relacionados con las interacciones y el estado de tus dispositivos."
        },
        "STEP_6": {
          "TITLE": "Escenas",
          "CONTENT": "Desde aquí puedes manipular todas las escenas que has creado."
        },
        "STEP_7": {
          "TITLE": "¡Eso es todo!",
          "CONTENT": "Puedes usar el menú de la izquierda para navegar a otras secciones en la aplicación. Si deseas ver esta ayuda nuevamente, usa el botón de ayuda en el menú superior."
        }
      },
      "DASHBOARD_WELCOME": {
        "STEP_1": {
          "TITLE": "¡Bienvenido!",
          "CONTENT": "Te ayudaremos a crear tu primer dispositivo, cuando estes listo haz click en las flechas u omite esta guía si lo deseas."
        },
        "STEP_2": {
          "CONTENT": "Pulsa el botón de agregar"
        },
        "STEP_3": {
          "CONTENT": "Pulsa en Dispositivos"
        }
      },
      "DASHBOARD_WELCOME_RETURN": {
        "STEP_1": {
          "CONTENT": "Tus dispositivos agregados aparecerán aquí, y en la lista de dispositivos, donde puedes controlarlos y monitorearlos."
        }
      },
      "DEVICES_HELP": {
        "STEP_1": {
          "TITLE": "Dispositivos",
          "CONTENT": "Al igual que en el dashboard, aquí puedes controlar, monitorear, editar y eliminar todos tus dispositivos."
        },
        "STEP_2": {
          "CONTENT": "Haz click en este botón para agregar nuevos dispositivos."
        },
        "STEP_3": {
          "CONTENT": "Busca tus dispositivos por nombre."
        },
        "STEP_4": {
          "CONTENT": "Filtra tus dispositivos por área."
        },
        "STEP_5": {
          "CONTENT": "Muestra todos los dispositivos ocultos, como el messenger."
        },
        "STEP_6": {
          "CONTENT": "Esto representa el estado actual de tu dispostivo:<ul><li class='online'>En línea</li><li class='processing'>Procesando</li><li class='offline'>Fuera de línea o con errores</li>"
        },
        "STEP_7": {
          "CONTENT": "Ve a los detalles del dispositivo, donde puedes cambiar su nombre e imagen, agregarlo a un área y mucho más."
        }
      },
      "DISCOVER_DEVICES_HELP": {
        "STEP_1": {
          "TITLE": "Descubrir Dispositivos",
          "CONTENT": "Desde aquí, puedes agregar y descubrir nuevos dispositivos, consultar las guías de usuario y comprarlos también."
        },
        "STEP_2": {
          "CONTENT": "Mientras te encuentres en esta sección, la aplicación intentará descubrir dispositivos automáticamente y te avisará cuando encuentre algo."
        },
        "STEP_3": {
          "CONTENT": "Esta es la lista de categorías de los diferentes dispositivos compatibles con la aplicación. Puedes usarlos para aprender más acerca de los dispositivos y agregarlos manualmente."
        }
      },
      "DISCOVER_DEVICES_WELCOME": {
        "STEP_1": {
          "CONTENT": "La aplicación está buscando dispositivos, por favor espera unos segundos... También puedes agregar dispositivos seleccionando la categoría correspondiente de la lista."
        },
        "STEP_2": {
          "CONTENT": "Hemos encontrado un dispositivo, por favor pulsa esta sección."
        },
        "STEP_3": {
          "CONTENT": "Esta es la lista de dispositivos agregados. Selecciona los dispositivos que quieras agregar y pulsa el botón Listo abajo."
        },
        "STEP_4": {
          "CONTENT": "Desde aquí, puedes agregar otros dispositivos, ¡o puedes ir al dashboard para empezar a usarlos!"
        }
      },
      "LOCATIONS_HELP": {
        "STEP_1": {
          "TITLE": "Ubicaciones",
          "CONTENT": "Puedes administrar todas tus ubicaciones físicas en esta sección, incluida su información, configuración y energía."
        },
        "STEP_2": {
          "CONTENT": "Haz click en este botón para agregar nuevas ubicaciones."
        },
        "STEP_3": {
          "CONTENT": "Busca tus ubicaciones por sus nombres."
        },
        "STEP_4": {
          "CONTENT": "Haz click en este botón para ver las opciones de la ubicación."
        },
        "STEP_5": {
          "CONTENT": "Administra tu ubicación usando estas opciones."
        }
      },
      "MICROAPPS_HELP": {
        "STEP_1": {
          "TITLE": "Micro Apps",
          "CONTENT": "Las micro apps te permiten controlar dispositivos centralmente para soportar escenarios de uso específicos en tu vida diaria. En esta sección, puedes crear nuevas micro apps, eliminarlas, asociar dispositivos a ellas y configurar acciones para notificarte cuando ocurra algo."
        },
        "STEP_2": {
          "CONTENT": "Tap on this button to add new micro apps."
        },
        "STEP_3": {
          "CONTENT": "Search your micro apps by their names."
        },
        "STEP_4": {
          "CONTENT": "Tap on this button to see the microapp options."
        },
        "STEP_5": {
          "CONTENT": "Manage your microapp using these options."
        }
      }
    }
  }
}
